/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const findCoachAppointmentAvailability = /* GraphQL */ `
  query FindCoachAppointmentAvailability(
    $input: AppointmentAvailabilityInput!
  ) {
    findCoachAppointmentAvailability(input: $input) {
      dates {
        date
        times {
          time
          slotsAvailable
        }
      }
    }
  }
`;
export const listUserAppointmentsByEmail = /* GraphQL */ `
  query ListUserAppointmentsByEmail(
    $email: AWSEmail!
    $expanded: Boolean
    $showall: Boolean
    $excludeForms: Boolean
    $canceled: Boolean
    $direction: SortDirectionEnum
    $limit: Int
    $minDate: AWSDate
    $maxDate: AWSDate
    $phone: AWSPhone
  ) {
    listUserAppointmentsByEmail(
      email: $email
      expanded: $expanded
      showall: $showall
      excludeForms: $excludeForms
      canceled: $canceled
      direction: $direction
      limit: $limit
      minDate: $minDate
      maxDate: $maxDate
      phone: $phone
    )
  }
`;
export const logEvent = /* GraphQL */ `
  query LogEvent(
    $eventName: String!
    $message: AWSJSON!
    $messageAttributes: AWSJSON
  ) {
    logEvent(
      eventName: $eventName
      message: $message
      messageAttributes: $messageAttributes
    )
  }
`;
export const getStripePaymentIntent = /* GraphQL */ `
  query GetStripePaymentIntent(
    $userId: String!
    $pricingId: String!
    $metadata: AWSJSON!
  ) {
    getStripePaymentIntent(
      userId: $userId
      pricingId: $pricingId
      metadata: $metadata
    )
  }
`;
export const addUserToChatChannel = /* GraphQL */ `
  query AddUserToChatChannel(
    $members: [String]!
    $channelId: String!
    $channelName: String!
    $defaultMessage: String
    $defaultMessageFromUserId: String
  ) {
    addUserToChatChannel(
      members: $members
      channelId: $channelId
      channelName: $channelName
      defaultMessage: $defaultMessage
      defaultMessageFromUserId: $defaultMessageFromUserId
    )
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      email
      firstName
      lastName
      phone
      address {
        houseNumber
        street
        streetType
        address1
        address2
        address3
        city
        state
        postalCode
        county
        country
        latLng {
          lat
          lon
        }
      }
      avatar
      userBio
      age
      dateOfBirth
      genderId
      createdAt
      status
      lastSeen
      referralSource
      roles
      stage
      plans {
        items {
          id
          userId
          planId
          plan {
            id
            planGroupId
            name
            description
            active
            defaultPrice
            defaultPlanPriceId
            discountsAllowed
            display
            isTrial
            upgradeable
            downgradeable
            features
            createdAt
            level
            updatedAt
          }
          planGroupId
          planGroup {
            id
            name
            startDate
            endDate
            trialPeriod
            createdAt
            active
            updatedAt
          }
          planPricingSlug
          planPricing {
            planId
            slug
            default
            activationCodes
            downgradePricingIds
            upgradePricingIds
            price
            createdAt
            updatedAt
          }
          startDate
          endDate
          cancelled
          cancellationReason
          createdAt
          active
          metadata {
            stripeSubscriptionId
            stripeCustomerId
          }
          updatedAt
        }
        nextToken
      }
      appointments {
        items {
          id
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          coachId
          coach {
            id
            firstName
            lastName
            email
            title
            coachType
            avatarUrl
            description
            active
            createdAt
            updatedAt
          }
          appointmentStartTime
          appointmentEndTime
          appointmentDurationMins
          appointmentTimezone
          appointmentType
          cancelled
          cancelDate
          cancelReason
          cancelNote
          metadata {
            acuityAppointmentId
            acuityAppointmentTypeId
            acuityConfirmationPageUrl
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      coaches {
        items {
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          coachId
          coach {
            id
            firstName
            lastName
            email
            title
            coachType
            avatarUrl
            description
            active
            createdAt
            updatedAt
          }
          isPrimary
          active
          coachingStartDate
          coachingEndDate
          ratings {
            nextToken
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      growthPaths {
        items {
          id
          growthPathItemId
          growthPathItem {
            id
            type
            title
            subtitle
            avatarUrl
            description
            categoryName
            categoryId
            estimatedCompletionTimeInMins
            actionTitle
            actionDestination
            actionPayload
            createdAt
            expirationDate
            lessonId
            tags
            isArchived
            updatedAt
          }
          userId
          order
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          dateTimeAdded
          completed
          dismissed
          completedTimestamp
          expirationDate
          locked
          hidden
          isScheduled
          visibleDate
          visibleTimestamp
          growthPathJourneyId
          growthPathJourneyStep
          growthPathJourney {
            id
            title
            description
            focusAreaId
            active
            createdAt
            updatedAt
          }
          coachId
          coach {
            id
            firstName
            lastName
            email
            title
            coachType
            avatarUrl
            description
            active
            createdAt
            updatedAt
          }
          source
          lastActivityTimestamp
          dependsOnGrowthPathItems
          createdAt
          updatedAt
        }
        nextToken
      }
      metadata {
        lastLogin
        trialStartDate
        trialEndDate
        subscriptionStatus
        deviceId
        deviceOS
        deviceOSVersion
        allowAccountNotifications
        allowMarketingNotifications
        allowCoachingNotifications
        initialAssessmentCompletedDate
        lastWeeklyCheckinDate
        lastGrowthStageAssessmentDate
        primaryFocusCategoryId
        primaryFocusGoalId
        secondaryFocusCategoryId
        secondaryFocusGoalId
        tertiaryFocusCategoryId
        tertiaryFocusGoalId
        preferredCoachingTimeOfDay
        preferredCoachingDaysOfWeek
        primaryCoachId
        userIPAddress
        intakeCompleted
        onboardingCompleted
        issCompleted
        stipeCustomerId
        lastActive
      }
      updatedAt
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const findUserByEmail = /* GraphQL */ `
  query FindUserByEmail(
    $email: AWSEmail!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    findUserByEmail(
      email: $email
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const searchUsers = /* GraphQL */ `
  query SearchUsers(
    $filter: SearchableUserFilterInput
    $sort: [SearchableUserSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableUserAggregationInput]
  ) {
    searchUsers(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
            }
          }
        }
      }
    }
  }
`;
export const getUserCoach = /* GraphQL */ `
  query GetUserCoach($userId: ID!, $coachId: ID!) {
    getUserCoach(userId: $userId, coachId: $coachId) {
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      coachId
      coach {
        id
        firstName
        lastName
        email
        title
        coachType
        avatarUrl
        description
        metadata {
          introVideoUrl
          gcalId
          calendlyId
          acuityCalendarId
          acuityUserId
          acuityKey
          acuityIssAppointmentId
          acuityRegularAppointmentId
          streamChatId
          slackId
          lastCoachNote
          lastChatMessage
        }
        focusAreas {
          items {
            id
            coachId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        members {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      isPrimary
      active
      coachingStartDate
      coachingEndDate
      ratings {
        items {
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          coachId
          coach {
            id
            firstName
            lastName
            email
            title
            coachType
            avatarUrl
            description
            active
            createdAt
            updatedAt
          }
          rating
          comment
          ratingTimestamp
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listUserCoaches = /* GraphQL */ `
  query ListUserCoaches(
    $userId: ID
    $coachId: ModelIDKeyConditionInput
    $filter: ModelUserCoachFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUserCoaches(
      userId: $userId
      coachId: $coachId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        userId
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        coachId
        coach {
          id
          firstName
          lastName
          email
          title
          coachType
          avatarUrl
          description
          metadata {
            introVideoUrl
            gcalId
            calendlyId
            acuityCalendarId
            acuityUserId
            acuityKey
            acuityIssAppointmentId
            acuityRegularAppointmentId
            streamChatId
            slackId
            lastCoachNote
            lastChatMessage
          }
          focusAreas {
            nextToken
          }
          members {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        isPrimary
        active
        coachingStartDate
        coachingEndDate
        ratings {
          items {
            userId
            coachId
            rating
            comment
            ratingTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listUserCoachByCoachId = /* GraphQL */ `
  query ListUserCoachByCoachId(
    $coachId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserCoachFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserCoachByCoachId(
      coachId: $coachId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        userId
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        coachId
        coach {
          id
          firstName
          lastName
          email
          title
          coachType
          avatarUrl
          description
          metadata {
            introVideoUrl
            gcalId
            calendlyId
            acuityCalendarId
            acuityUserId
            acuityKey
            acuityIssAppointmentId
            acuityRegularAppointmentId
            streamChatId
            slackId
            lastCoachNote
            lastChatMessage
          }
          focusAreas {
            nextToken
          }
          members {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        isPrimary
        active
        coachingStartDate
        coachingEndDate
        ratings {
          items {
            userId
            coachId
            rating
            comment
            ratingTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listUserCoachByCoachIdByStartDate = /* GraphQL */ `
  query ListUserCoachByCoachIdByStartDate(
    $coachId: ID!
    $coachingStartDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserCoachFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserCoachByCoachIdByStartDate(
      coachId: $coachId
      coachingStartDate: $coachingStartDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        userId
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        coachId
        coach {
          id
          firstName
          lastName
          email
          title
          coachType
          avatarUrl
          description
          metadata {
            introVideoUrl
            gcalId
            calendlyId
            acuityCalendarId
            acuityUserId
            acuityKey
            acuityIssAppointmentId
            acuityRegularAppointmentId
            streamChatId
            slackId
            lastCoachNote
            lastChatMessage
          }
          focusAreas {
            nextToken
          }
          members {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        isPrimary
        active
        coachingStartDate
        coachingEndDate
        ratings {
          items {
            userId
            coachId
            rating
            comment
            ratingTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listUserCoachByIsPrimary = /* GraphQL */ `
  query ListUserCoachByIsPrimary(
    $isPrimary: BoolEnum!
    $sortDirection: ModelSortDirection
    $filter: ModelUserCoachFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserCoachByIsPrimary(
      isPrimary: $isPrimary
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        userId
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        coachId
        coach {
          id
          firstName
          lastName
          email
          title
          coachType
          avatarUrl
          description
          metadata {
            introVideoUrl
            gcalId
            calendlyId
            acuityCalendarId
            acuityUserId
            acuityKey
            acuityIssAppointmentId
            acuityRegularAppointmentId
            streamChatId
            slackId
            lastCoachNote
            lastChatMessage
          }
          focusAreas {
            nextToken
          }
          members {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        isPrimary
        active
        coachingStartDate
        coachingEndDate
        ratings {
          items {
            userId
            coachId
            rating
            comment
            ratingTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserCoachRating = /* GraphQL */ `
  query GetUserCoachRating($userId: ID!, $coachId: ID!) {
    getUserCoachRating(userId: $userId, coachId: $coachId) {
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      coachId
      coach {
        id
        firstName
        lastName
        email
        title
        coachType
        avatarUrl
        description
        metadata {
          introVideoUrl
          gcalId
          calendlyId
          acuityCalendarId
          acuityUserId
          acuityKey
          acuityIssAppointmentId
          acuityRegularAppointmentId
          streamChatId
          slackId
          lastCoachNote
          lastChatMessage
        }
        focusAreas {
          items {
            id
            coachId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        members {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      rating
      comment
      ratingTimestamp
      createdAt
      updatedAt
    }
  }
`;
export const listUserCoachRatings = /* GraphQL */ `
  query ListUserCoachRatings(
    $userId: ID
    $coachId: ModelIDKeyConditionInput
    $filter: ModelUserCoachRatingFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUserCoachRatings(
      userId: $userId
      coachId: $coachId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        userId
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        coachId
        coach {
          id
          firstName
          lastName
          email
          title
          coachType
          avatarUrl
          description
          metadata {
            introVideoUrl
            gcalId
            calendlyId
            acuityCalendarId
            acuityUserId
            acuityKey
            acuityIssAppointmentId
            acuityRegularAppointmentId
            streamChatId
            slackId
            lastCoachNote
            lastChatMessage
          }
          focusAreas {
            nextToken
          }
          members {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        rating
        comment
        ratingTimestamp
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listUserCoachRatingsByCoachId = /* GraphQL */ `
  query ListUserCoachRatingsByCoachId(
    $coachId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserCoachRatingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserCoachRatingsByCoachId(
      coachId: $coachId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        userId
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        coachId
        coach {
          id
          firstName
          lastName
          email
          title
          coachType
          avatarUrl
          description
          metadata {
            introVideoUrl
            gcalId
            calendlyId
            acuityCalendarId
            acuityUserId
            acuityKey
            acuityIssAppointmentId
            acuityRegularAppointmentId
            streamChatId
            slackId
            lastCoachNote
            lastChatMessage
          }
          focusAreas {
            nextToken
          }
          members {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        rating
        comment
        ratingTimestamp
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserCoachingNote = /* GraphQL */ `
  query GetUserCoachingNote($id: ID!) {
    getUserCoachingNote(id: $id) {
      id
      userId
      coachId
      appointmentId
      appointment {
        id
        userId
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        coachId
        coach {
          id
          firstName
          lastName
          email
          title
          coachType
          avatarUrl
          description
          metadata {
            introVideoUrl
            gcalId
            calendlyId
            acuityCalendarId
            acuityUserId
            acuityKey
            acuityIssAppointmentId
            acuityRegularAppointmentId
            streamChatId
            slackId
            lastCoachNote
            lastChatMessage
          }
          focusAreas {
            nextToken
          }
          members {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        appointmentStartTime
        appointmentEndTime
        appointmentDurationMins
        appointmentTimezone
        appointmentType
        cancelled
        cancelDate
        cancelReason
        cancelNote
        metadata {
          acuityAppointmentId
          acuityAppointmentTypeId
          acuityConfirmationPageUrl
        }
        createdAt
        updatedAt
      }
      note
      visibleToUser
      createdAt
      updatedAt
    }
  }
`;
export const listUserCoachingNotes = /* GraphQL */ `
  query ListUserCoachingNotes(
    $filter: ModelUserCoachingNoteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserCoachingNotes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        coachId
        appointmentId
        appointment {
          id
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          coachId
          coach {
            id
            firstName
            lastName
            email
            title
            coachType
            avatarUrl
            description
            active
            createdAt
            updatedAt
          }
          appointmentStartTime
          appointmentEndTime
          appointmentDurationMins
          appointmentTimezone
          appointmentType
          cancelled
          cancelDate
          cancelReason
          cancelNote
          metadata {
            acuityAppointmentId
            acuityAppointmentTypeId
            acuityConfirmationPageUrl
          }
          createdAt
          updatedAt
        }
        note
        visibleToUser
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listUserCoachingNotesByUserIdByCreatedDate = /* GraphQL */ `
  query ListUserCoachingNotesByUserIdByCreatedDate(
    $userId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserCoachingNoteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserCoachingNotesByUserIdByCreatedDate(
      userId: $userId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        coachId
        appointmentId
        appointment {
          id
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          coachId
          coach {
            id
            firstName
            lastName
            email
            title
            coachType
            avatarUrl
            description
            active
            createdAt
            updatedAt
          }
          appointmentStartTime
          appointmentEndTime
          appointmentDurationMins
          appointmentTimezone
          appointmentType
          cancelled
          cancelDate
          cancelReason
          cancelNote
          metadata {
            acuityAppointmentId
            acuityAppointmentTypeId
            acuityConfirmationPageUrl
          }
          createdAt
          updatedAt
        }
        note
        visibleToUser
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserStats = /* GraphQL */ `
  query GetUserStats($userId: ID!) {
    getUserStats(userId: $userId) {
      userId
      totalHabitLogged
      totalAppointmentsScheduled
      totalLessonsWatched
      totalLogins
      totalMessages
      createdAt
      updatedAt
    }
  }
`;
export const listUserStats = /* GraphQL */ `
  query ListUserStats(
    $userId: ID
    $filter: ModelUserStatsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUserStats(
      userId: $userId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        userId
        totalHabitLogged
        totalAppointmentsScheduled
        totalLessonsWatched
        totalLogins
        totalMessages
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserActivityLog = /* GraphQL */ `
  query GetUserActivityLog($id: ID!) {
    getUserActivityLog(id: $id) {
      id
      type
      source
      payload
      timestamp
      createdAt
      updatedAt
    }
  }
`;
export const listUserActivityLogs = /* GraphQL */ `
  query ListUserActivityLogs(
    $filter: ModelUserActivityLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserActivityLogs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        source
        payload
        timestamp
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listUserActivityLogByTypeByTimestamp = /* GraphQL */ `
  query ListUserActivityLogByTypeByTimestamp(
    $type: UserActivitiesEnum!
    $timestamp: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserActivityLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserActivityLogByTypeByTimestamp(
      type: $type
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        source
        payload
        timestamp
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getJournalEntryTemplates = /* GraphQL */ `
  query GetJournalEntryTemplates($id: ID!, $createdAt: AWSDateTime!) {
    getJournalEntryTemplates(id: $id, createdAt: $createdAt) {
      id
      name
      description
      templateText
      templateBlocks {
        label
        value
      }
      createdAt
      updatedAt
    }
  }
`;
export const listJournalEntryTemplates = /* GraphQL */ `
  query ListJournalEntryTemplates(
    $id: ID
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelJournalEntryTemplatesFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listJournalEntryTemplates(
      id: $id
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        description
        templateText
        templateBlocks {
          label
          value
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserJournalEntryLog = /* GraphQL */ `
  query GetUserJournalEntryLog($userId: ID!, $createdAt: AWSDateTime!) {
    getUserJournalEntryLog(userId: $userId, createdAt: $createdAt) {
      userId
      entryTitle
      entryLogType
      entryLogTags {
        label
        value
      }
      isVisibleToCoach
      isVisibleToPublic
      entryText
      entryBlocks {
        label
        value
      }
      journalEntryTemplateId
      rawEntry
      createdAt
      updatedAt
    }
  }
`;
export const listUserJournalEntryLogs = /* GraphQL */ `
  query ListUserJournalEntryLogs(
    $userId: ID
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelUserJournalEntryLogFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUserJournalEntryLogs(
      userId: $userId
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        userId
        entryTitle
        entryLogType
        entryLogTags {
          label
          value
        }
        isVisibleToCoach
        isVisibleToPublic
        entryText
        entryBlocks {
          label
          value
        }
        journalEntryTemplateId
        rawEntry
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listUserJournalEntryLogsByLogTypeByCreatedAt = /* GraphQL */ `
  query ListUserJournalEntryLogsByLogTypeByCreatedAt(
    $entryLogType: JournalEntryLogTypeEnum!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserJournalEntryLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserJournalEntryLogsByLogTypeByCreatedAt(
      entryLogType: $entryLogType
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        userId
        entryTitle
        entryLogType
        entryLogTags {
          label
          value
        }
        isVisibleToCoach
        isVisibleToPublic
        entryText
        entryBlocks {
          label
          value
        }
        journalEntryTemplateId
        rawEntry
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listJournalEntryLogByUserIdByDate = /* GraphQL */ `
  query ListJournalEntryLogByUserIdByDate(
    $entryLogType: JournalEntryLogTypeEnum!
    $userIdCreatedAt: ModelUserJournalEntryLogJournalEntryLogByUserIdByDateCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserJournalEntryLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listJournalEntryLogByUserIdByDate(
      entryLogType: $entryLogType
      userIdCreatedAt: $userIdCreatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        userId
        entryTitle
        entryLogType
        entryLogTags {
          label
          value
        }
        isVisibleToCoach
        isVisibleToPublic
        entryText
        entryBlocks {
          label
          value
        }
        journalEntryTemplateId
        rawEntry
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const searchUserJournalEntryLogs = /* GraphQL */ `
  query SearchUserJournalEntryLogs(
    $filter: SearchableUserJournalEntryLogFilterInput
    $sort: [SearchableUserJournalEntryLogSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableUserJournalEntryLogAggregationInput]
  ) {
    searchUserJournalEntryLogs(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        userId
        entryTitle
        entryLogType
        entryLogTags {
          label
          value
        }
        isVisibleToCoach
        isVisibleToPublic
        entryText
        entryBlocks {
          label
          value
        }
        journalEntryTemplateId
        rawEntry
        createdAt
        updatedAt
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
            }
          }
        }
      }
    }
  }
`;
export const getUserPlan = /* GraphQL */ `
  query GetUserPlan($id: ID!) {
    getUserPlan(id: $id) {
      id
      userId
      planId
      plan {
        id
        planGroupId
        planGroup {
          id
          name
          startDate
          endDate
          trialPeriod
          createdAt
          active
          plans {
            nextToken
          }
          updatedAt
        }
        name
        description
        active
        defaultPrice
        defaultPlanPriceId
        discountsAllowed
        display
        isTrial
        upgradeable
        downgradeable
        features
        createdAt
        level
        pricing {
          items {
            planId
            slug
            default
            activationCodes
            downgradePricingIds
            upgradePricingIds
            price
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          coachingSessionsAllocated
          stripeProductId
        }
        updatedAt
      }
      planGroupId
      planGroup {
        id
        name
        startDate
        endDate
        trialPeriod
        createdAt
        active
        plans {
          items {
            id
            planGroupId
            name
            description
            active
            defaultPrice
            defaultPlanPriceId
            discountsAllowed
            display
            isTrial
            upgradeable
            downgradeable
            features
            createdAt
            level
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      planPricingSlug
      planPricing {
        planId
        plan {
          id
          planGroupId
          planGroup {
            id
            name
            startDate
            endDate
            trialPeriod
            createdAt
            active
            updatedAt
          }
          name
          description
          active
          defaultPrice
          defaultPlanPriceId
          discountsAllowed
          display
          isTrial
          upgradeable
          downgradeable
          features
          createdAt
          level
          pricing {
            nextToken
          }
          metadata {
            coachingSessionsAllocated
            stripeProductId
          }
          updatedAt
        }
        slug
        default
        activationCodes
        downgradePricingIds
        upgradePricingIds
        price
        metadata {
          stripePriceId
        }
        createdAt
        updatedAt
      }
      startDate
      endDate
      cancelled
      cancellationReason
      createdAt
      active
      metadata {
        stripeSubscriptionId
        stripeCustomerId
      }
      updatedAt
    }
  }
`;
export const listUserPlans = /* GraphQL */ `
  query ListUserPlans(
    $filter: ModelUserPlanFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserPlans(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        planId
        plan {
          id
          planGroupId
          planGroup {
            id
            name
            startDate
            endDate
            trialPeriod
            createdAt
            active
            updatedAt
          }
          name
          description
          active
          defaultPrice
          defaultPlanPriceId
          discountsAllowed
          display
          isTrial
          upgradeable
          downgradeable
          features
          createdAt
          level
          pricing {
            nextToken
          }
          metadata {
            coachingSessionsAllocated
            stripeProductId
          }
          updatedAt
        }
        planGroupId
        planGroup {
          id
          name
          startDate
          endDate
          trialPeriod
          createdAt
          active
          plans {
            nextToken
          }
          updatedAt
        }
        planPricingSlug
        planPricing {
          planId
          plan {
            id
            planGroupId
            name
            description
            active
            defaultPrice
            defaultPlanPriceId
            discountsAllowed
            display
            isTrial
            upgradeable
            downgradeable
            features
            createdAt
            level
            updatedAt
          }
          slug
          default
          activationCodes
          downgradePricingIds
          upgradePricingIds
          price
          metadata {
            stripePriceId
          }
          createdAt
          updatedAt
        }
        startDate
        endDate
        cancelled
        cancellationReason
        createdAt
        active
        metadata {
          stripeSubscriptionId
          stripeCustomerId
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const listUserPlansByUserId = /* GraphQL */ `
  query ListUserPlansByUserId(
    $userId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserPlanFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserPlansByUserId(
      userId: $userId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        planId
        plan {
          id
          planGroupId
          planGroup {
            id
            name
            startDate
            endDate
            trialPeriod
            createdAt
            active
            updatedAt
          }
          name
          description
          active
          defaultPrice
          defaultPlanPriceId
          discountsAllowed
          display
          isTrial
          upgradeable
          downgradeable
          features
          createdAt
          level
          pricing {
            nextToken
          }
          metadata {
            coachingSessionsAllocated
            stripeProductId
          }
          updatedAt
        }
        planGroupId
        planGroup {
          id
          name
          startDate
          endDate
          trialPeriod
          createdAt
          active
          plans {
            nextToken
          }
          updatedAt
        }
        planPricingSlug
        planPricing {
          planId
          plan {
            id
            planGroupId
            name
            description
            active
            defaultPrice
            defaultPlanPriceId
            discountsAllowed
            display
            isTrial
            upgradeable
            downgradeable
            features
            createdAt
            level
            updatedAt
          }
          slug
          default
          activationCodes
          downgradePricingIds
          upgradePricingIds
          price
          metadata {
            stripePriceId
          }
          createdAt
          updatedAt
        }
        startDate
        endDate
        cancelled
        cancellationReason
        createdAt
        active
        metadata {
          stripeSubscriptionId
          stripeCustomerId
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserCoachingCredits = /* GraphQL */ `
  query GetUserCoachingCredits($userId: ID!, $yearMonth: Int!) {
    getUserCoachingCredits(userId: $userId, yearMonth: $yearMonth) {
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      yearMonth
      creditsAwarded
      creditsRemaining
      lastUsedTimestamp
      createdAt
      updatedAt
    }
  }
`;
export const listUserCoachingCredits = /* GraphQL */ `
  query ListUserCoachingCredits(
    $userId: ID
    $yearMonth: ModelIntKeyConditionInput
    $filter: ModelUserCoachingCreditsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUserCoachingCredits(
      userId: $userId
      yearMonth: $yearMonth
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        userId
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        yearMonth
        creditsAwarded
        creditsRemaining
        lastUsedTimestamp
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserCoachingCreditUsageLog = /* GraphQL */ `
  query GetUserCoachingCreditUsageLog($id: ID!) {
    getUserCoachingCreditUsageLog(id: $id) {
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      memo
      timestamp
      id
      createdAt
      updatedAt
    }
  }
`;
export const listUserCoachingCreditUsageLogs = /* GraphQL */ `
  query ListUserCoachingCreditUsageLogs(
    $filter: ModelUserCoachingCreditUsageLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserCoachingCreditUsageLogs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        userId
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        memo
        timestamp
        id
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserFocusArea = /* GraphQL */ `
  query GetUserFocusArea($id: ID!) {
    getUserFocusArea(id: $id) {
      id
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      startDate
      endDate
      completed
      dateCompleted
      userFocusAreaGoals {
        items {
          id
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalId
          focusAreaGoal {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          userFocusAreaGoalHabits {
            nextToken
          }
          completed
          dateCompleted
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listUserFocusAreas = /* GraphQL */ `
  query ListUserFocusAreas(
    $filter: ModelUserFocusAreaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserFocusAreas(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        startDate
        endDate
        completed
        dateCompleted
        userFocusAreaGoals {
          items {
            id
            userId
            focusAreaId
            focusAreaGoalId
            completed
            dateCompleted
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listUserFocusAreasByUserId = /* GraphQL */ `
  query ListUserFocusAreasByUserId(
    $userId: ID!
    $startDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserFocusAreaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserFocusAreasByUserId(
      userId: $userId
      startDate: $startDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        startDate
        endDate
        completed
        dateCompleted
        userFocusAreaGoals {
          items {
            id
            userId
            focusAreaId
            focusAreaGoalId
            completed
            dateCompleted
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listUserFocusAreasByFocusAreaId = /* GraphQL */ `
  query ListUserFocusAreasByFocusAreaId(
    $focusAreaId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserFocusAreaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserFocusAreasByFocusAreaId(
      focusAreaId: $focusAreaId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        startDate
        endDate
        completed
        dateCompleted
        userFocusAreaGoals {
          items {
            id
            userId
            focusAreaId
            focusAreaGoalId
            completed
            dateCompleted
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserFocusAreaGoals = /* GraphQL */ `
  query GetUserFocusAreaGoals($id: ID!) {
    getUserFocusAreaGoals(id: $id) {
      id
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      focusAreaGoalId
      focusAreaGoal {
        id
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        focusAreaGoalHabits {
          items {
            id
            focusAreaId
            focusAreaGoalId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        name
        slug
        description
        createdAt
        updatedAt
      }
      userFocusAreaGoalHabits {
        items {
          id
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalId
          focusAreaGoal {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalHabitId
          focusAreaGoalHabit {
            id
            focusAreaId
            focusAreaGoalId
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalHabitLog {
            nextToken
          }
          createdAt
          completed
          dateCompleted
          updatedAt
        }
        nextToken
      }
      completed
      dateCompleted
      createdAt
      updatedAt
    }
  }
`;
export const listUserFocusAreaGoals = /* GraphQL */ `
  query ListUserFocusAreaGoals(
    $filter: ModelUserFocusAreaGoalsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserFocusAreaGoals(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        focusAreaGoalId
        focusAreaGoal {
          id
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalHabits {
            nextToken
          }
          name
          slug
          description
          createdAt
          updatedAt
        }
        userFocusAreaGoalHabits {
          items {
            id
            userId
            focusAreaId
            focusAreaGoalId
            focusAreaGoalHabitId
            createdAt
            completed
            dateCompleted
            updatedAt
          }
          nextToken
        }
        completed
        dateCompleted
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listUserFocusAreaGoalsByUserIdByFocusAreaId = /* GraphQL */ `
  query ListUserFocusAreaGoalsByUserIdByFocusAreaId(
    $userId: ID!
    $focusAreaId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserFocusAreaGoalsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserFocusAreaGoalsByUserIdByFocusAreaId(
      userId: $userId
      focusAreaId: $focusAreaId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        focusAreaGoalId
        focusAreaGoal {
          id
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalHabits {
            nextToken
          }
          name
          slug
          description
          createdAt
          updatedAt
        }
        userFocusAreaGoalHabits {
          items {
            id
            userId
            focusAreaId
            focusAreaGoalId
            focusAreaGoalHabitId
            createdAt
            completed
            dateCompleted
            updatedAt
          }
          nextToken
        }
        completed
        dateCompleted
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listUserFocusAreaGoalsByfocusAreaId = /* GraphQL */ `
  query ListUserFocusAreaGoalsByfocusAreaId(
    $focusAreaId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserFocusAreaGoalsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserFocusAreaGoalsByfocusAreaId(
      focusAreaId: $focusAreaId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        focusAreaGoalId
        focusAreaGoal {
          id
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalHabits {
            nextToken
          }
          name
          slug
          description
          createdAt
          updatedAt
        }
        userFocusAreaGoalHabits {
          items {
            id
            userId
            focusAreaId
            focusAreaGoalId
            focusAreaGoalHabitId
            createdAt
            completed
            dateCompleted
            updatedAt
          }
          nextToken
        }
        completed
        dateCompleted
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserFocusAreaGoalHabit = /* GraphQL */ `
  query GetUserFocusAreaGoalHabit($id: ID!) {
    getUserFocusAreaGoalHabit(id: $id) {
      id
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      focusAreaGoalId
      focusAreaGoal {
        id
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        focusAreaGoalHabits {
          items {
            id
            focusAreaId
            focusAreaGoalId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        name
        slug
        description
        createdAt
        updatedAt
      }
      focusAreaGoalHabitId
      focusAreaGoalHabit {
        id
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        focusAreaGoalId
        focusAreaGoal {
          id
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalHabits {
            nextToken
          }
          name
          slug
          description
          createdAt
          updatedAt
        }
        name
        slug
        description
        createdAt
        updatedAt
      }
      focusAreaGoalHabitLog {
        items {
          id
          userId
          userFocusAreaGoalHabitId
          year
          month
          week
          day
          note
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      completed
      dateCompleted
      updatedAt
    }
  }
`;
export const listUserFocusAreaGoalHabits = /* GraphQL */ `
  query ListUserFocusAreaGoalHabits(
    $filter: ModelUserFocusAreaGoalHabitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserFocusAreaGoalHabits(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        focusAreaGoalId
        focusAreaGoal {
          id
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalHabits {
            nextToken
          }
          name
          slug
          description
          createdAt
          updatedAt
        }
        focusAreaGoalHabitId
        focusAreaGoalHabit {
          id
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalId
          focusAreaGoal {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          name
          slug
          description
          createdAt
          updatedAt
        }
        focusAreaGoalHabitLog {
          items {
            id
            userId
            userFocusAreaGoalHabitId
            year
            month
            week
            day
            note
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        completed
        dateCompleted
        updatedAt
      }
      nextToken
    }
  }
`;
export const listUserFocusAreaGoalHabitByUserIdByFocusAreaGoalId = /* GraphQL */ `
  query ListUserFocusAreaGoalHabitByUserIdByFocusAreaGoalId(
    $userId: ID!
    $focusAreaIdFocusAreaGoalId: ModelUserFocusAreaGoalHabitFocusAreaGoalHabitByUserIdByFocusAreaGoalIdCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserFocusAreaGoalHabitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserFocusAreaGoalHabitByUserIdByFocusAreaGoalId(
      userId: $userId
      focusAreaIdFocusAreaGoalId: $focusAreaIdFocusAreaGoalId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        focusAreaGoalId
        focusAreaGoal {
          id
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalHabits {
            nextToken
          }
          name
          slug
          description
          createdAt
          updatedAt
        }
        focusAreaGoalHabitId
        focusAreaGoalHabit {
          id
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalId
          focusAreaGoal {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          name
          slug
          description
          createdAt
          updatedAt
        }
        focusAreaGoalHabitLog {
          items {
            id
            userId
            userFocusAreaGoalHabitId
            year
            month
            week
            day
            note
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        completed
        dateCompleted
        updatedAt
      }
      nextToken
    }
  }
`;
export const listUserFocusAreaGoalHabitByFocusAreaId = /* GraphQL */ `
  query ListUserFocusAreaGoalHabitByFocusAreaId(
    $focusAreaGoalId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserFocusAreaGoalHabitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserFocusAreaGoalHabitByFocusAreaId(
      focusAreaGoalId: $focusAreaGoalId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        focusAreaGoalId
        focusAreaGoal {
          id
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalHabits {
            nextToken
          }
          name
          slug
          description
          createdAt
          updatedAt
        }
        focusAreaGoalHabitId
        focusAreaGoalHabit {
          id
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalId
          focusAreaGoal {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          name
          slug
          description
          createdAt
          updatedAt
        }
        focusAreaGoalHabitLog {
          items {
            id
            userId
            userFocusAreaGoalHabitId
            year
            month
            week
            day
            note
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        completed
        dateCompleted
        updatedAt
      }
      nextToken
    }
  }
`;
export const listUserFocusAreaGoalHabitByFocusAreaGoalHabitId = /* GraphQL */ `
  query ListUserFocusAreaGoalHabitByFocusAreaGoalHabitId(
    $focusAreaGoalHabitId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserFocusAreaGoalHabitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserFocusAreaGoalHabitByFocusAreaGoalHabitId(
      focusAreaGoalHabitId: $focusAreaGoalHabitId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        focusAreaGoalId
        focusAreaGoal {
          id
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalHabits {
            nextToken
          }
          name
          slug
          description
          createdAt
          updatedAt
        }
        focusAreaGoalHabitId
        focusAreaGoalHabit {
          id
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalId
          focusAreaGoal {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          name
          slug
          description
          createdAt
          updatedAt
        }
        focusAreaGoalHabitLog {
          items {
            id
            userId
            userFocusAreaGoalHabitId
            year
            month
            week
            day
            note
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        completed
        dateCompleted
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserFocusAreaGoalHabitLog = /* GraphQL */ `
  query GetUserFocusAreaGoalHabitLog($id: ID!) {
    getUserFocusAreaGoalHabitLog(id: $id) {
      id
      userId
      userFocusAreaGoalHabitId
      year
      month
      week
      day
      note
      createdAt
      updatedAt
    }
  }
`;
export const listUserFocusAreaGoalHabitLogs = /* GraphQL */ `
  query ListUserFocusAreaGoalHabitLogs(
    $filter: ModelUserFocusAreaGoalHabitLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserFocusAreaGoalHabitLogs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        userFocusAreaGoalHabitId
        year
        month
        week
        day
        note
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listUserFocusAreaGoalHabitLogByUserFocusAreaHabitId = /* GraphQL */ `
  query ListUserFocusAreaGoalHabitLogByUserFocusAreaHabitId(
    $userFocusAreaGoalHabitId: ID!
    $yearWeekMonthDay: ModelUserFocusAreaGoalHabitLogUserFocusAreaGoalHabitLogByUserFocusAreaHabitIdCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserFocusAreaGoalHabitLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserFocusAreaGoalHabitLogByUserFocusAreaHabitId(
      userFocusAreaGoalHabitId: $userFocusAreaGoalHabitId
      yearWeekMonthDay: $yearWeekMonthDay
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        userFocusAreaGoalHabitId
        year
        month
        week
        day
        note
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserAssessmentLog = /* GraphQL */ `
  query GetUserAssessmentLog($id: ID!) {
    getUserAssessmentLog(id: $id) {
      id
      createdAt
      userId
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      assessment
      score
      maxScore
      userNotified
      coachReviewed
      updatedAt
    }
  }
`;
export const listUserAssessmentLogs = /* GraphQL */ `
  query ListUserAssessmentLogs(
    $filter: ModelUserAssessmentLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserAssessmentLogs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        userId
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        assessment
        score
        maxScore
        userNotified
        coachReviewed
        updatedAt
      }
      nextToken
    }
  }
`;
export const listUserAssessmentLogByUserId = /* GraphQL */ `
  query ListUserAssessmentLogByUserId(
    $userId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserAssessmentLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserAssessmentLogByUserId(
      userId: $userId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        userId
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        assessment
        score
        maxScore
        userNotified
        coachReviewed
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserLessons = /* GraphQL */ `
  query GetUserLessons($id: ID!) {
    getUserLessons(id: $id) {
      id
      userId
      lessonId
      lesson {
        id
        programId
        program {
          id
          name
          description
          level
          lessons {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        name
        order
        durationInMins
        description
        transcript
        focusAreas {
          items {
            lessonId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        tags
        lessonType
        metadata {
          videoUrl
          videoStreamUrl
          videoExternalId
          videoDistributionPage
          formUrl
          formExternalId
        }
        coverImageUrl
        isPremium
        active
        createdAt
        updatedAt
      }
      startTimestamp
      completedTimestamp
      lastViewedTimestamp
      completed
      createdAt
      updatedAt
    }
  }
`;
export const listUserLessons = /* GraphQL */ `
  query ListUserLessons(
    $filter: ModelUserLessonsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserLessons(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        lessonId
        lesson {
          id
          programId
          program {
            id
            name
            description
            level
            active
            createdAt
            updatedAt
          }
          name
          order
          durationInMins
          description
          transcript
          focusAreas {
            nextToken
          }
          tags
          lessonType
          metadata {
            videoUrl
            videoStreamUrl
            videoExternalId
            videoDistributionPage
            formUrl
            formExternalId
          }
          coverImageUrl
          isPremium
          active
          createdAt
          updatedAt
        }
        startTimestamp
        completedTimestamp
        lastViewedTimestamp
        completed
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listUserLessonsByUserId = /* GraphQL */ `
  query ListUserLessonsByUserId(
    $userId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserLessonsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserLessonsByUserId(
      userId: $userId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        lessonId
        lesson {
          id
          programId
          program {
            id
            name
            description
            level
            active
            createdAt
            updatedAt
          }
          name
          order
          durationInMins
          description
          transcript
          focusAreas {
            nextToken
          }
          tags
          lessonType
          metadata {
            videoUrl
            videoStreamUrl
            videoExternalId
            videoDistributionPage
            formUrl
            formExternalId
          }
          coverImageUrl
          isPremium
          active
          createdAt
          updatedAt
        }
        startTimestamp
        completedTimestamp
        lastViewedTimestamp
        completed
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listUserLessonsByLessonId = /* GraphQL */ `
  query ListUserLessonsByLessonId(
    $lessonId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserLessonsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserLessonsByLessonId(
      lessonId: $lessonId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        lessonId
        lesson {
          id
          programId
          program {
            id
            name
            description
            level
            active
            createdAt
            updatedAt
          }
          name
          order
          durationInMins
          description
          transcript
          focusAreas {
            nextToken
          }
          tags
          lessonType
          metadata {
            videoUrl
            videoStreamUrl
            videoExternalId
            videoDistributionPage
            formUrl
            formExternalId
          }
          coverImageUrl
          isPremium
          active
          createdAt
          updatedAt
        }
        startTimestamp
        completedTimestamp
        lastViewedTimestamp
        completed
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listUserLessonsByLessonIdByUserByCreatedAt = /* GraphQL */ `
  query ListUserLessonsByLessonIdByUserByCreatedAt(
    $lessonId: ID!
    $userIdCreatedAt: ModelUserLessonsUserLessonsByLessonIdByUserByCreatedAtCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserLessonsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserLessonsByLessonIdByUserByCreatedAt(
      lessonId: $lessonId
      userIdCreatedAt: $userIdCreatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        lessonId
        lesson {
          id
          programId
          program {
            id
            name
            description
            level
            active
            createdAt
            updatedAt
          }
          name
          order
          durationInMins
          description
          transcript
          focusAreas {
            nextToken
          }
          tags
          lessonType
          metadata {
            videoUrl
            videoStreamUrl
            videoExternalId
            videoDistributionPage
            formUrl
            formExternalId
          }
          coverImageUrl
          isPremium
          active
          createdAt
          updatedAt
        }
        startTimestamp
        completedTimestamp
        lastViewedTimestamp
        completed
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserGrowthPathItem = /* GraphQL */ `
  query GetUserGrowthPathItem($id: ID!) {
    getUserGrowthPathItem(id: $id) {
      id
      growthPathItemId
      growthPathItem {
        id
        type
        title
        subtitle
        avatarUrl
        description
        categoryName
        categoryId
        estimatedCompletionTimeInMins
        actionTitle
        actionDestination
        actionPayload
        createdAt
        expirationDate
        lessonId
        lesson {
          id
          programId
          program {
            id
            name
            description
            level
            active
            createdAt
            updatedAt
          }
          name
          order
          durationInMins
          description
          transcript
          focusAreas {
            nextToken
          }
          tags
          lessonType
          metadata {
            videoUrl
            videoStreamUrl
            videoExternalId
            videoDistributionPage
            formUrl
            formExternalId
          }
          coverImageUrl
          isPremium
          active
          createdAt
          updatedAt
        }
        tags
        isArchived
        updatedAt
      }
      userId
      order
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      dateTimeAdded
      completed
      dismissed
      completedTimestamp
      expirationDate
      locked
      hidden
      isScheduled
      visibleDate
      visibleTimestamp
      growthPathJourneyId
      growthPathJourneyStep
      growthPathJourney {
        id
        title
        description
        growthPathItems {
          step
          growthPathItemId
          rules {
            ruleType
            dependencyGrowthPathItemId
            scheduleDaysFromNow
          }
        }
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        active
        createdAt
        updatedAt
      }
      coachId
      coach {
        id
        firstName
        lastName
        email
        title
        coachType
        avatarUrl
        description
        metadata {
          introVideoUrl
          gcalId
          calendlyId
          acuityCalendarId
          acuityUserId
          acuityKey
          acuityIssAppointmentId
          acuityRegularAppointmentId
          streamChatId
          slackId
          lastCoachNote
          lastChatMessage
        }
        focusAreas {
          items {
            id
            coachId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        members {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      source
      lastActivityTimestamp
      dependsOnGrowthPathItems
      createdAt
      updatedAt
    }
  }
`;
export const listUserGrowthPathItems = /* GraphQL */ `
  query ListUserGrowthPathItems(
    $filter: ModelUserGrowthPathItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserGrowthPathItems(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        growthPathItemId
        growthPathItem {
          id
          type
          title
          subtitle
          avatarUrl
          description
          categoryName
          categoryId
          estimatedCompletionTimeInMins
          actionTitle
          actionDestination
          actionPayload
          createdAt
          expirationDate
          lessonId
          lesson {
            id
            programId
            name
            order
            durationInMins
            description
            transcript
            tags
            lessonType
            coverImageUrl
            isPremium
            active
            createdAt
            updatedAt
          }
          tags
          isArchived
          updatedAt
        }
        userId
        order
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        dateTimeAdded
        completed
        dismissed
        completedTimestamp
        expirationDate
        locked
        hidden
        isScheduled
        visibleDate
        visibleTimestamp
        growthPathJourneyId
        growthPathJourneyStep
        growthPathJourney {
          id
          title
          description
          growthPathItems {
            step
            growthPathItemId
          }
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          active
          createdAt
          updatedAt
        }
        coachId
        coach {
          id
          firstName
          lastName
          email
          title
          coachType
          avatarUrl
          description
          metadata {
            introVideoUrl
            gcalId
            calendlyId
            acuityCalendarId
            acuityUserId
            acuityKey
            acuityIssAppointmentId
            acuityRegularAppointmentId
            streamChatId
            slackId
            lastCoachNote
            lastChatMessage
          }
          focusAreas {
            nextToken
          }
          members {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        source
        lastActivityTimestamp
        dependsOnGrowthPathItems
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listGrowthPathsByUserId = /* GraphQL */ `
  query ListGrowthPathsByUserId(
    $userId: ID!
    $dateTimeAdded: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserGrowthPathItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGrowthPathsByUserId(
      userId: $userId
      dateTimeAdded: $dateTimeAdded
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        growthPathItemId
        growthPathItem {
          id
          type
          title
          subtitle
          avatarUrl
          description
          categoryName
          categoryId
          estimatedCompletionTimeInMins
          actionTitle
          actionDestination
          actionPayload
          createdAt
          expirationDate
          lessonId
          lesson {
            id
            programId
            name
            order
            durationInMins
            description
            transcript
            tags
            lessonType
            coverImageUrl
            isPremium
            active
            createdAt
            updatedAt
          }
          tags
          isArchived
          updatedAt
        }
        userId
        order
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        dateTimeAdded
        completed
        dismissed
        completedTimestamp
        expirationDate
        locked
        hidden
        isScheduled
        visibleDate
        visibleTimestamp
        growthPathJourneyId
        growthPathJourneyStep
        growthPathJourney {
          id
          title
          description
          growthPathItems {
            step
            growthPathItemId
          }
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          active
          createdAt
          updatedAt
        }
        coachId
        coach {
          id
          firstName
          lastName
          email
          title
          coachType
          avatarUrl
          description
          metadata {
            introVideoUrl
            gcalId
            calendlyId
            acuityCalendarId
            acuityUserId
            acuityKey
            acuityIssAppointmentId
            acuityRegularAppointmentId
            streamChatId
            slackId
            lastCoachNote
            lastChatMessage
          }
          focusAreas {
            nextToken
          }
          members {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        source
        lastActivityTimestamp
        dependsOnGrowthPathItems
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserGrowthPathJourney = /* GraphQL */ `
  query GetUserGrowthPathJourney($id: ID!) {
    getUserGrowthPathJourney(id: $id) {
      userId
      growthPathJourneyId
      growthPathJourney {
        id
        title
        description
        growthPathItems {
          step
          growthPathItemId
          rules {
            ruleType
            dependencyGrowthPathItemId
            scheduleDaysFromNow
          }
        }
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        active
        createdAt
        updatedAt
      }
      completionLog {
        growthPathItemId
        completionTimestamp
      }
      lastActivityTimestamp
      active
      id
      createdAt
      updatedAt
    }
  }
`;
export const listUserGrowthPathJourneys = /* GraphQL */ `
  query ListUserGrowthPathJourneys(
    $filter: ModelUserGrowthPathJourneyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserGrowthPathJourneys(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        userId
        growthPathJourneyId
        growthPathJourney {
          id
          title
          description
          growthPathItems {
            step
            growthPathItemId
          }
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          active
          createdAt
          updatedAt
        }
        completionLog {
          growthPathItemId
          completionTimestamp
        }
        lastActivityTimestamp
        active
        id
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getGrowthPathJourney = /* GraphQL */ `
  query GetGrowthPathJourney($id: ID!) {
    getGrowthPathJourney(id: $id) {
      id
      title
      description
      growthPathItems {
        step
        growthPathItemId
        rules {
          ruleType
          dependencyGrowthPathItemId
          scheduleDaysFromNow
        }
      }
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      active
      createdAt
      updatedAt
    }
  }
`;
export const listGrowthPathJourneys = /* GraphQL */ `
  query ListGrowthPathJourneys(
    $filter: ModelGrowthPathJourneyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGrowthPathJourneys(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        growthPathItems {
          step
          growthPathItemId
          rules {
            ruleType
            dependencyGrowthPathItemId
            scheduleDaysFromNow
          }
        }
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        active
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listGrowthPathJourneyByFocusAreaId = /* GraphQL */ `
  query ListGrowthPathJourneyByFocusAreaId(
    $focusAreaId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelGrowthPathJourneyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGrowthPathJourneyByFocusAreaId(
      focusAreaId: $focusAreaId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        growthPathItems {
          step
          growthPathItemId
          rules {
            ruleType
            dependencyGrowthPathItemId
            scheduleDaysFromNow
          }
        }
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        active
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listGrowthPathJourneyByFocusAreaByActive = /* GraphQL */ `
  query ListGrowthPathJourneyByFocusAreaByActive(
    $focusAreaId: ID!
    $active: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelGrowthPathJourneyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGrowthPathJourneyByFocusAreaByActive(
      focusAreaId: $focusAreaId
      active: $active
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        growthPathItems {
          step
          growthPathItemId
          rules {
            ruleType
            dependencyGrowthPathItemId
            scheduleDaysFromNow
          }
        }
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        active
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserAppointments = /* GraphQL */ `
  query GetUserAppointments($id: ID!) {
    getUserAppointments(id: $id) {
      id
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      coachId
      coach {
        id
        firstName
        lastName
        email
        title
        coachType
        avatarUrl
        description
        metadata {
          introVideoUrl
          gcalId
          calendlyId
          acuityCalendarId
          acuityUserId
          acuityKey
          acuityIssAppointmentId
          acuityRegularAppointmentId
          streamChatId
          slackId
          lastCoachNote
          lastChatMessage
        }
        focusAreas {
          items {
            id
            coachId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        members {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      appointmentStartTime
      appointmentEndTime
      appointmentDurationMins
      appointmentTimezone
      appointmentType
      cancelled
      cancelDate
      cancelReason
      cancelNote
      metadata {
        acuityAppointmentId
        acuityAppointmentTypeId
        acuityConfirmationPageUrl
      }
      createdAt
      updatedAt
    }
  }
`;
export const listUserAppointments = /* GraphQL */ `
  query ListUserAppointments(
    $filter: ModelUserAppointmentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserAppointments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        coachId
        coach {
          id
          firstName
          lastName
          email
          title
          coachType
          avatarUrl
          description
          metadata {
            introVideoUrl
            gcalId
            calendlyId
            acuityCalendarId
            acuityUserId
            acuityKey
            acuityIssAppointmentId
            acuityRegularAppointmentId
            streamChatId
            slackId
            lastCoachNote
            lastChatMessage
          }
          focusAreas {
            nextToken
          }
          members {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        appointmentStartTime
        appointmentEndTime
        appointmentDurationMins
        appointmentTimezone
        appointmentType
        cancelled
        cancelDate
        cancelReason
        cancelNote
        metadata {
          acuityAppointmentId
          acuityAppointmentTypeId
          acuityConfirmationPageUrl
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listUserAppointmentsByUserId = /* GraphQL */ `
  query ListUserAppointmentsByUserId(
    $userId: ID!
    $appointmentStartTime: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserAppointmentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserAppointmentsByUserId(
      userId: $userId
      appointmentStartTime: $appointmentStartTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        coachId
        coach {
          id
          firstName
          lastName
          email
          title
          coachType
          avatarUrl
          description
          metadata {
            introVideoUrl
            gcalId
            calendlyId
            acuityCalendarId
            acuityUserId
            acuityKey
            acuityIssAppointmentId
            acuityRegularAppointmentId
            streamChatId
            slackId
            lastCoachNote
            lastChatMessage
          }
          focusAreas {
            nextToken
          }
          members {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        appointmentStartTime
        appointmentEndTime
        appointmentDurationMins
        appointmentTimezone
        appointmentType
        cancelled
        cancelDate
        cancelReason
        cancelNote
        metadata {
          acuityAppointmentId
          acuityAppointmentTypeId
          acuityConfirmationPageUrl
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listAllUserAppointementsByCoachId = /* GraphQL */ `
  query ListAllUserAppointementsByCoachId(
    $coachId: ID!
    $appointmentStartTime: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserAppointmentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAllUserAppointementsByCoachId(
      coachId: $coachId
      appointmentStartTime: $appointmentStartTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        coachId
        coach {
          id
          firstName
          lastName
          email
          title
          coachType
          avatarUrl
          description
          metadata {
            introVideoUrl
            gcalId
            calendlyId
            acuityCalendarId
            acuityUserId
            acuityKey
            acuityIssAppointmentId
            acuityRegularAppointmentId
            streamChatId
            slackId
            lastCoachNote
            lastChatMessage
          }
          focusAreas {
            nextToken
          }
          members {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        appointmentStartTime
        appointmentEndTime
        appointmentDurationMins
        appointmentTimezone
        appointmentType
        cancelled
        cancelDate
        cancelReason
        cancelNote
        metadata {
          acuityAppointmentId
          acuityAppointmentTypeId
          acuityConfirmationPageUrl
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserNotification = /* GraphQL */ `
  query GetUserNotification($id: ID!) {
    getUserNotification(id: $id) {
      id
      userId
      notificationType
      notificationMessage
      notificationTitle
      notificationExpirationDate
      notificationRead
      createdAt
      updatedAt
    }
  }
`;
export const listUserNotifications = /* GraphQL */ `
  query ListUserNotifications(
    $filter: ModelUserNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserNotifications(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        notificationType
        notificationMessage
        notificationTitle
        notificationExpirationDate
        notificationRead
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listUserNotificationsByUserId = /* GraphQL */ `
  query ListUserNotificationsByUserId(
    $userId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserNotificationsByUserId(
      userId: $userId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        notificationType
        notificationMessage
        notificationTitle
        notificationExpirationDate
        notificationRead
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listUserNotificationsByTypeByUserByCreatedAt = /* GraphQL */ `
  query ListUserNotificationsByTypeByUserByCreatedAt(
    $notificationType: UserNotificationTypeEnum!
    $userIdCreatedAt: ModelUserNotificationUserNotificationsByNotificationTypeCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserNotificationsByTypeByUserByCreatedAt(
      notificationType: $notificationType
      userIdCreatedAt: $userIdCreatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        notificationType
        notificationMessage
        notificationTitle
        notificationExpirationDate
        notificationRead
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCoach = /* GraphQL */ `
  query GetCoach($id: ID!) {
    getCoach(id: $id) {
      id
      firstName
      lastName
      email
      title
      coachType
      avatarUrl
      description
      metadata {
        introVideoUrl
        gcalId
        calendlyId
        acuityCalendarId
        acuityUserId
        acuityKey
        acuityIssAppointmentId
        acuityRegularAppointmentId
        streamChatId
        slackId
        lastCoachNote
        lastChatMessage
      }
      focusAreas {
        items {
          id
          coachId
          coach {
            id
            firstName
            lastName
            email
            title
            coachType
            avatarUrl
            description
            active
            createdAt
            updatedAt
          }
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      members {
        items {
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          coachId
          coach {
            id
            firstName
            lastName
            email
            title
            coachType
            avatarUrl
            description
            active
            createdAt
            updatedAt
          }
          isPrimary
          active
          coachingStartDate
          coachingEndDate
          ratings {
            nextToken
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      active
      createdAt
      updatedAt
    }
  }
`;
export const listCoaches = /* GraphQL */ `
  query ListCoaches(
    $filter: ModelCoachFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCoaches(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstName
        lastName
        email
        title
        coachType
        avatarUrl
        description
        metadata {
          introVideoUrl
          gcalId
          calendlyId
          acuityCalendarId
          acuityUserId
          acuityKey
          acuityIssAppointmentId
          acuityRegularAppointmentId
          streamChatId
          slackId
          lastCoachNote
          lastChatMessage
        }
        focusAreas {
          items {
            id
            coachId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        members {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const findCoachByEmail = /* GraphQL */ `
  query FindCoachByEmail(
    $email: String!
    $sortDirection: ModelSortDirection
    $filter: ModelCoachFilterInput
    $limit: Int
    $nextToken: String
  ) {
    findCoachByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        lastName
        email
        title
        coachType
        avatarUrl
        description
        metadata {
          introVideoUrl
          gcalId
          calendlyId
          acuityCalendarId
          acuityUserId
          acuityKey
          acuityIssAppointmentId
          acuityRegularAppointmentId
          streamChatId
          slackId
          lastCoachNote
          lastChatMessage
        }
        focusAreas {
          items {
            id
            coachId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        members {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listUserCoachByActive = /* GraphQL */ `
  query ListUserCoachByActive(
    $active: BoolEnum!
    $sortDirection: ModelSortDirection
    $filter: ModelCoachFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserCoachByActive(
      active: $active
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        lastName
        email
        title
        coachType
        avatarUrl
        description
        metadata {
          introVideoUrl
          gcalId
          calendlyId
          acuityCalendarId
          acuityUserId
          acuityKey
          acuityIssAppointmentId
          acuityRegularAppointmentId
          streamChatId
          slackId
          lastCoachNote
          lastChatMessage
        }
        focusAreas {
          items {
            id
            coachId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        members {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCoachFocusArea = /* GraphQL */ `
  query GetCoachFocusArea($id: ID!) {
    getCoachFocusArea(id: $id) {
      id
      coachId
      coach {
        id
        firstName
        lastName
        email
        title
        coachType
        avatarUrl
        description
        metadata {
          introVideoUrl
          gcalId
          calendlyId
          acuityCalendarId
          acuityUserId
          acuityKey
          acuityIssAppointmentId
          acuityRegularAppointmentId
          streamChatId
          slackId
          lastCoachNote
          lastChatMessage
        }
        focusAreas {
          items {
            id
            coachId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        members {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listCoachFocusAreas = /* GraphQL */ `
  query ListCoachFocusAreas(
    $filter: ModelCoachFocusAreaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCoachFocusAreas(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        coachId
        coach {
          id
          firstName
          lastName
          email
          title
          coachType
          avatarUrl
          description
          metadata {
            introVideoUrl
            gcalId
            calendlyId
            acuityCalendarId
            acuityUserId
            acuityKey
            acuityIssAppointmentId
            acuityRegularAppointmentId
            streamChatId
            slackId
            lastCoachNote
            lastChatMessage
          }
          focusAreas {
            nextToken
          }
          members {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listCoachFocusAreasByCoachId = /* GraphQL */ `
  query ListCoachFocusAreasByCoachId(
    $coachId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCoachFocusAreaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCoachFocusAreasByCoachId(
      coachId: $coachId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        coachId
        coach {
          id
          firstName
          lastName
          email
          title
          coachType
          avatarUrl
          description
          metadata {
            introVideoUrl
            gcalId
            calendlyId
            acuityCalendarId
            acuityUserId
            acuityKey
            acuityIssAppointmentId
            acuityRegularAppointmentId
            streamChatId
            slackId
            lastCoachNote
            lastChatMessage
          }
          focusAreas {
            nextToken
          }
          members {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listCoachFocusAreasByFocusAreaId = /* GraphQL */ `
  query ListCoachFocusAreasByFocusAreaId(
    $focusAreaId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCoachFocusAreaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCoachFocusAreasByFocusAreaId(
      focusAreaId: $focusAreaId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        coachId
        coach {
          id
          firstName
          lastName
          email
          title
          coachType
          avatarUrl
          description
          metadata {
            introVideoUrl
            gcalId
            calendlyId
            acuityCalendarId
            acuityUserId
            acuityKey
            acuityIssAppointmentId
            acuityRegularAppointmentId
            streamChatId
            slackId
            lastCoachNote
            lastChatMessage
          }
          focusAreas {
            nextToken
          }
          members {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCoachUserNotification = /* GraphQL */ `
  query GetCoachUserNotification($id: ID!) {
    getCoachUserNotification(id: $id) {
      id
      coachId
      coach {
        id
        firstName
        lastName
        email
        title
        coachType
        avatarUrl
        description
        metadata {
          introVideoUrl
          gcalId
          calendlyId
          acuityCalendarId
          acuityUserId
          acuityKey
          acuityIssAppointmentId
          acuityRegularAppointmentId
          streamChatId
          slackId
          lastCoachNote
          lastChatMessage
        }
        focusAreas {
          items {
            id
            coachId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        members {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      title
      read
      readTimestamp
      notificationType
      rawPayload
      createdAt
      updatedAt
    }
  }
`;
export const listCoachUserNotifications = /* GraphQL */ `
  query ListCoachUserNotifications(
    $filter: ModelCoachUserNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCoachUserNotifications(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        coachId
        coach {
          id
          firstName
          lastName
          email
          title
          coachType
          avatarUrl
          description
          metadata {
            introVideoUrl
            gcalId
            calendlyId
            acuityCalendarId
            acuityUserId
            acuityKey
            acuityIssAppointmentId
            acuityRegularAppointmentId
            streamChatId
            slackId
            lastCoachNote
            lastChatMessage
          }
          focusAreas {
            nextToken
          }
          members {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        userId
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        title
        read
        readTimestamp
        notificationType
        rawPayload
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listCoachUserNotificationsByCoachId = /* GraphQL */ `
  query ListCoachUserNotificationsByCoachId(
    $coachId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCoachUserNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCoachUserNotificationsByCoachId(
      coachId: $coachId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        coachId
        coach {
          id
          firstName
          lastName
          email
          title
          coachType
          avatarUrl
          description
          metadata {
            introVideoUrl
            gcalId
            calendlyId
            acuityCalendarId
            acuityUserId
            acuityKey
            acuityIssAppointmentId
            acuityRegularAppointmentId
            streamChatId
            slackId
            lastCoachNote
            lastChatMessage
          }
          focusAreas {
            nextToken
          }
          members {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        userId
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        title
        read
        readTimestamp
        notificationType
        rawPayload
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listCoachUserNotificationsByUserId = /* GraphQL */ `
  query ListCoachUserNotificationsByUserId(
    $userId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCoachUserNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCoachUserNotificationsByUserId(
      userId: $userId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        coachId
        coach {
          id
          firstName
          lastName
          email
          title
          coachType
          avatarUrl
          description
          metadata {
            introVideoUrl
            gcalId
            calendlyId
            acuityCalendarId
            acuityUserId
            acuityKey
            acuityIssAppointmentId
            acuityRegularAppointmentId
            streamChatId
            slackId
            lastCoachNote
            lastChatMessage
          }
          focusAreas {
            nextToken
          }
          members {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        userId
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        title
        read
        readTimestamp
        notificationType
        rawPayload
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getGrowthPathItem = /* GraphQL */ `
  query GetGrowthPathItem($id: ID!) {
    getGrowthPathItem(id: $id) {
      id
      type
      title
      subtitle
      avatarUrl
      description
      categoryName
      categoryId
      estimatedCompletionTimeInMins
      actionTitle
      actionDestination
      actionPayload
      createdAt
      expirationDate
      lessonId
      lesson {
        id
        programId
        program {
          id
          name
          description
          level
          lessons {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        name
        order
        durationInMins
        description
        transcript
        focusAreas {
          items {
            lessonId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        tags
        lessonType
        metadata {
          videoUrl
          videoStreamUrl
          videoExternalId
          videoDistributionPage
          formUrl
          formExternalId
        }
        coverImageUrl
        isPremium
        active
        createdAt
        updatedAt
      }
      tags
      isArchived
      updatedAt
    }
  }
`;
export const listGrowthPathItems = /* GraphQL */ `
  query ListGrowthPathItems(
    $filter: ModelGrowthPathItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGrowthPathItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        type
        title
        subtitle
        avatarUrl
        description
        categoryName
        categoryId
        estimatedCompletionTimeInMins
        actionTitle
        actionDestination
        actionPayload
        createdAt
        expirationDate
        lessonId
        lesson {
          id
          programId
          program {
            id
            name
            description
            level
            active
            createdAt
            updatedAt
          }
          name
          order
          durationInMins
          description
          transcript
          focusAreas {
            nextToken
          }
          tags
          lessonType
          metadata {
            videoUrl
            videoStreamUrl
            videoExternalId
            videoDistributionPage
            formUrl
            formExternalId
          }
          coverImageUrl
          isPremium
          active
          createdAt
          updatedAt
        }
        tags
        isArchived
        updatedAt
      }
      nextToken
    }
  }
`;
export const listGrowthPathItemByType = /* GraphQL */ `
  query ListGrowthPathItemByType(
    $type: GrowthPathCardTypeEnum!
    $sortDirection: ModelSortDirection
    $filter: ModelGrowthPathItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGrowthPathItemByType(
      type: $type
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        title
        subtitle
        avatarUrl
        description
        categoryName
        categoryId
        estimatedCompletionTimeInMins
        actionTitle
        actionDestination
        actionPayload
        createdAt
        expirationDate
        lessonId
        lesson {
          id
          programId
          program {
            id
            name
            description
            level
            active
            createdAt
            updatedAt
          }
          name
          order
          durationInMins
          description
          transcript
          focusAreas {
            nextToken
          }
          tags
          lessonType
          metadata {
            videoUrl
            videoStreamUrl
            videoExternalId
            videoDistributionPage
            formUrl
            formExternalId
          }
          coverImageUrl
          isPremium
          active
          createdAt
          updatedAt
        }
        tags
        isArchived
        updatedAt
      }
      nextToken
    }
  }
`;
export const getTopicTags = /* GraphQL */ `
  query GetTopicTags($slug: String!) {
    getTopicTags(slug: $slug) {
      slug
      name
      description
      createdAt
      updatedAt
    }
  }
`;
export const listTopicTags = /* GraphQL */ `
  query ListTopicTags(
    $slug: String
    $filter: ModelTopicTagsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listTopicTags(
      slug: $slug
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        slug
        name
        description
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getFocusArea = /* GraphQL */ `
  query GetFocusArea($id: ID!) {
    getFocusArea(id: $id) {
      id
      name
      slug
      description
      focusAreaGoals {
        items {
          id
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalHabits {
            nextToken
          }
          name
          slug
          description
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listFocusAreas = /* GraphQL */ `
  query ListFocusAreas(
    $filter: ModelFocusAreaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFocusAreas(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getFocusAreaGoal = /* GraphQL */ `
  query GetFocusAreaGoal($id: ID!) {
    getFocusAreaGoal(id: $id) {
      id
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      focusAreaGoalHabits {
        items {
          id
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalId
          focusAreaGoal {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          name
          slug
          description
          createdAt
          updatedAt
        }
        nextToken
      }
      name
      slug
      description
      createdAt
      updatedAt
    }
  }
`;
export const listFocusAreaGoals = /* GraphQL */ `
  query ListFocusAreaGoals(
    $filter: ModelFocusAreaGoalFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFocusAreaGoals(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        focusAreaGoalHabits {
          items {
            id
            focusAreaId
            focusAreaGoalId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        name
        slug
        description
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listFocusAreaGoalsByFocusAreaId = /* GraphQL */ `
  query ListFocusAreaGoalsByFocusAreaId(
    $focusAreaId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelFocusAreaGoalFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFocusAreaGoalsByFocusAreaId(
      focusAreaId: $focusAreaId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        focusAreaGoalHabits {
          items {
            id
            focusAreaId
            focusAreaGoalId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        name
        slug
        description
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getFocusAreaGoalHabits = /* GraphQL */ `
  query GetFocusAreaGoalHabits($id: ID!) {
    getFocusAreaGoalHabits(id: $id) {
      id
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      focusAreaGoalId
      focusAreaGoal {
        id
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        focusAreaGoalHabits {
          items {
            id
            focusAreaId
            focusAreaGoalId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        name
        slug
        description
        createdAt
        updatedAt
      }
      name
      slug
      description
      createdAt
      updatedAt
    }
  }
`;
export const listFocusAreaGoalHabits = /* GraphQL */ `
  query ListFocusAreaGoalHabits(
    $filter: ModelFocusAreaGoalHabitsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFocusAreaGoalHabits(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        focusAreaGoalId
        focusAreaGoal {
          id
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalHabits {
            nextToken
          }
          name
          slug
          description
          createdAt
          updatedAt
        }
        name
        slug
        description
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listFocusAreaGoalHabitsByFocusAreaId = /* GraphQL */ `
  query ListFocusAreaGoalHabitsByFocusAreaId(
    $focusAreaId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelFocusAreaGoalHabitsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFocusAreaGoalHabitsByFocusAreaId(
      focusAreaId: $focusAreaId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        focusAreaGoalId
        focusAreaGoal {
          id
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalHabits {
            nextToken
          }
          name
          slug
          description
          createdAt
          updatedAt
        }
        name
        slug
        description
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listFocusAreaGoalHabitsByFocusAreaGoalId = /* GraphQL */ `
  query ListFocusAreaGoalHabitsByFocusAreaGoalId(
    $focusAreaGoalId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelFocusAreaGoalHabitsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFocusAreaGoalHabitsByFocusAreaGoalId(
      focusAreaGoalId: $focusAreaGoalId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        focusAreaGoalId
        focusAreaGoal {
          id
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalHabits {
            nextToken
          }
          name
          slug
          description
          createdAt
          updatedAt
        }
        name
        slug
        description
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getProgram = /* GraphQL */ `
  query GetProgram($id: ID!) {
    getProgram(id: $id) {
      id
      name
      description
      level
      lessons {
        items {
          id
          programId
          program {
            id
            name
            description
            level
            active
            createdAt
            updatedAt
          }
          name
          order
          durationInMins
          description
          transcript
          focusAreas {
            nextToken
          }
          tags
          lessonType
          metadata {
            videoUrl
            videoStreamUrl
            videoExternalId
            videoDistributionPage
            formUrl
            formExternalId
          }
          coverImageUrl
          isPremium
          active
          createdAt
          updatedAt
        }
        nextToken
      }
      active
      createdAt
      updatedAt
    }
  }
`;
export const listPrograms = /* GraphQL */ `
  query ListPrograms(
    $filter: ModelProgramFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPrograms(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        level
        lessons {
          items {
            id
            programId
            name
            order
            durationInMins
            description
            transcript
            tags
            lessonType
            coverImageUrl
            isPremium
            active
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listProgramsByActiveBbyLevels = /* GraphQL */ `
  query ListProgramsByActiveBbyLevels(
    $active: BoolEnum!
    $level: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProgramFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProgramsByActiveBbyLevels(
      active: $active
      level: $level
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        level
        lessons {
          items {
            id
            programId
            name
            order
            durationInMins
            description
            transcript
            tags
            lessonType
            coverImageUrl
            isPremium
            active
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getLesson = /* GraphQL */ `
  query GetLesson($id: ID!) {
    getLesson(id: $id) {
      id
      programId
      program {
        id
        name
        description
        level
        lessons {
          items {
            id
            programId
            name
            order
            durationInMins
            description
            transcript
            tags
            lessonType
            coverImageUrl
            isPremium
            active
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      name
      order
      durationInMins
      description
      transcript
      focusAreas {
        items {
          lessonId
          lesson {
            id
            programId
            name
            order
            durationInMins
            description
            transcript
            tags
            lessonType
            coverImageUrl
            isPremium
            active
            createdAt
            updatedAt
          }
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      tags
      lessonType
      metadata {
        videoUrl
        videoStreamUrl
        videoExternalId
        videoDistributionPage
        formUrl
        formExternalId
      }
      coverImageUrl
      isPremium
      active
      createdAt
      updatedAt
    }
  }
`;
export const listLessons = /* GraphQL */ `
  query ListLessons(
    $filter: ModelLessonFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLessons(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        programId
        program {
          id
          name
          description
          level
          lessons {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        name
        order
        durationInMins
        description
        transcript
        focusAreas {
          items {
            lessonId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        tags
        lessonType
        metadata {
          videoUrl
          videoStreamUrl
          videoExternalId
          videoDistributionPage
          formUrl
          formExternalId
        }
        coverImageUrl
        isPremium
        active
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listLessonsByProgramIdByOrder = /* GraphQL */ `
  query ListLessonsByProgramIdByOrder(
    $programId: ID!
    $order: ModelFloatKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLessonFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLessonsByProgramIdByOrder(
      programId: $programId
      order: $order
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        programId
        program {
          id
          name
          description
          level
          lessons {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        name
        order
        durationInMins
        description
        transcript
        focusAreas {
          items {
            lessonId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        tags
        lessonType
        metadata {
          videoUrl
          videoStreamUrl
          videoExternalId
          videoDistributionPage
          formUrl
          formExternalId
        }
        coverImageUrl
        isPremium
        active
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listLessonsByName = /* GraphQL */ `
  query ListLessonsByName(
    $name: String!
    $order: ModelFloatKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLessonFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLessonsByName(
      name: $name
      order: $order
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        programId
        program {
          id
          name
          description
          level
          lessons {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        name
        order
        durationInMins
        description
        transcript
        focusAreas {
          items {
            lessonId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        tags
        lessonType
        metadata {
          videoUrl
          videoStreamUrl
          videoExternalId
          videoDistributionPage
          formUrl
          formExternalId
        }
        coverImageUrl
        isPremium
        active
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listLessonsByActiveBbyOrder = /* GraphQL */ `
  query ListLessonsByActiveBbyOrder(
    $active: BoolEnum!
    $order: ModelFloatKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLessonFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLessonsByActiveBbyOrder(
      active: $active
      order: $order
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        programId
        program {
          id
          name
          description
          level
          lessons {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        name
        order
        durationInMins
        description
        transcript
        focusAreas {
          items {
            lessonId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        tags
        lessonType
        metadata {
          videoUrl
          videoStreamUrl
          videoExternalId
          videoDistributionPage
          formUrl
          formExternalId
        }
        coverImageUrl
        isPremium
        active
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getLessonFocusArea = /* GraphQL */ `
  query GetLessonFocusArea($lessonId: ID!, $focusAreaId: ID!) {
    getLessonFocusArea(lessonId: $lessonId, focusAreaId: $focusAreaId) {
      lessonId
      lesson {
        id
        programId
        program {
          id
          name
          description
          level
          lessons {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        name
        order
        durationInMins
        description
        transcript
        focusAreas {
          items {
            lessonId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        tags
        lessonType
        metadata {
          videoUrl
          videoStreamUrl
          videoExternalId
          videoDistributionPage
          formUrl
          formExternalId
        }
        coverImageUrl
        isPremium
        active
        createdAt
        updatedAt
      }
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listLessonFocusAreas = /* GraphQL */ `
  query ListLessonFocusAreas(
    $lessonId: ID
    $focusAreaId: ModelIDKeyConditionInput
    $filter: ModelLessonFocusAreaFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listLessonFocusAreas(
      lessonId: $lessonId
      focusAreaId: $focusAreaId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        lessonId
        lesson {
          id
          programId
          program {
            id
            name
            description
            level
            active
            createdAt
            updatedAt
          }
          name
          order
          durationInMins
          description
          transcript
          focusAreas {
            nextToken
          }
          tags
          lessonType
          metadata {
            videoUrl
            videoStreamUrl
            videoExternalId
            videoDistributionPage
            formUrl
            formExternalId
          }
          coverImageUrl
          isPremium
          active
          createdAt
          updatedAt
        }
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listLessonFocusAreasByFocusAreaId = /* GraphQL */ `
  query ListLessonFocusAreasByFocusAreaId(
    $focusAreaId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelLessonFocusAreaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLessonFocusAreasByFocusAreaId(
      focusAreaId: $focusAreaId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        lessonId
        lesson {
          id
          programId
          program {
            id
            name
            description
            level
            active
            createdAt
            updatedAt
          }
          name
          order
          durationInMins
          description
          transcript
          focusAreas {
            nextToken
          }
          tags
          lessonType
          metadata {
            videoUrl
            videoStreamUrl
            videoExternalId
            videoDistributionPage
            formUrl
            formExternalId
          }
          coverImageUrl
          isPremium
          active
          createdAt
          updatedAt
        }
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getPlanGroup = /* GraphQL */ `
  query GetPlanGroup($id: ID!) {
    getPlanGroup(id: $id) {
      id
      name
      startDate
      endDate
      trialPeriod
      createdAt
      active
      plans {
        items {
          id
          planGroupId
          planGroup {
            id
            name
            startDate
            endDate
            trialPeriod
            createdAt
            active
            updatedAt
          }
          name
          description
          active
          defaultPrice
          defaultPlanPriceId
          discountsAllowed
          display
          isTrial
          upgradeable
          downgradeable
          features
          createdAt
          level
          pricing {
            nextToken
          }
          metadata {
            coachingSessionsAllocated
            stripeProductId
          }
          updatedAt
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const listPlanGroups = /* GraphQL */ `
  query ListPlanGroups(
    $filter: ModelPlanGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPlanGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        startDate
        endDate
        trialPeriod
        createdAt
        active
        plans {
          items {
            id
            planGroupId
            name
            description
            active
            defaultPrice
            defaultPlanPriceId
            discountsAllowed
            display
            isTrial
            upgradeable
            downgradeable
            features
            createdAt
            level
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const listPlanGroupsByActiveByEndDate = /* GraphQL */ `
  query ListPlanGroupsByActiveByEndDate(
    $active: BoolEnum!
    $endDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPlanGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPlanGroupsByActiveByEndDate(
      active: $active
      endDate: $endDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        startDate
        endDate
        trialPeriod
        createdAt
        active
        plans {
          items {
            id
            planGroupId
            name
            description
            active
            defaultPrice
            defaultPlanPriceId
            discountsAllowed
            display
            isTrial
            upgradeable
            downgradeable
            features
            createdAt
            level
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const getPlan = /* GraphQL */ `
  query GetPlan($id: ID!) {
    getPlan(id: $id) {
      id
      planGroupId
      planGroup {
        id
        name
        startDate
        endDate
        trialPeriod
        createdAt
        active
        plans {
          items {
            id
            planGroupId
            name
            description
            active
            defaultPrice
            defaultPlanPriceId
            discountsAllowed
            display
            isTrial
            upgradeable
            downgradeable
            features
            createdAt
            level
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      name
      description
      active
      defaultPrice
      defaultPlanPriceId
      discountsAllowed
      display
      isTrial
      upgradeable
      downgradeable
      features
      createdAt
      level
      pricing {
        items {
          planId
          plan {
            id
            planGroupId
            name
            description
            active
            defaultPrice
            defaultPlanPriceId
            discountsAllowed
            display
            isTrial
            upgradeable
            downgradeable
            features
            createdAt
            level
            updatedAt
          }
          slug
          default
          activationCodes
          downgradePricingIds
          upgradePricingIds
          price
          metadata {
            stripePriceId
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      metadata {
        coachingSessionsAllocated
        stripeProductId
      }
      updatedAt
    }
  }
`;
export const listPlans = /* GraphQL */ `
  query ListPlans(
    $filter: ModelPlanFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPlans(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        planGroupId
        planGroup {
          id
          name
          startDate
          endDate
          trialPeriod
          createdAt
          active
          plans {
            nextToken
          }
          updatedAt
        }
        name
        description
        active
        defaultPrice
        defaultPlanPriceId
        discountsAllowed
        display
        isTrial
        upgradeable
        downgradeable
        features
        createdAt
        level
        pricing {
          items {
            planId
            slug
            default
            activationCodes
            downgradePricingIds
            upgradePricingIds
            price
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          coachingSessionsAllocated
          stripeProductId
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const listPlansByGroupIdByLevel = /* GraphQL */ `
  query ListPlansByGroupIdByLevel(
    $planGroupId: ID!
    $level: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPlanFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPlansByGroupIdByLevel(
      planGroupId: $planGroupId
      level: $level
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        planGroupId
        planGroup {
          id
          name
          startDate
          endDate
          trialPeriod
          createdAt
          active
          plans {
            nextToken
          }
          updatedAt
        }
        name
        description
        active
        defaultPrice
        defaultPlanPriceId
        discountsAllowed
        display
        isTrial
        upgradeable
        downgradeable
        features
        createdAt
        level
        pricing {
          items {
            planId
            slug
            default
            activationCodes
            downgradePricingIds
            upgradePricingIds
            price
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          coachingSessionsAllocated
          stripeProductId
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const getPlanPricing = /* GraphQL */ `
  query GetPlanPricing($planId: ID!, $slug: String!) {
    getPlanPricing(planId: $planId, slug: $slug) {
      planId
      plan {
        id
        planGroupId
        planGroup {
          id
          name
          startDate
          endDate
          trialPeriod
          createdAt
          active
          plans {
            nextToken
          }
          updatedAt
        }
        name
        description
        active
        defaultPrice
        defaultPlanPriceId
        discountsAllowed
        display
        isTrial
        upgradeable
        downgradeable
        features
        createdAt
        level
        pricing {
          items {
            planId
            slug
            default
            activationCodes
            downgradePricingIds
            upgradePricingIds
            price
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          coachingSessionsAllocated
          stripeProductId
        }
        updatedAt
      }
      slug
      default
      activationCodes
      downgradePricingIds
      upgradePricingIds
      price
      metadata {
        stripePriceId
      }
      createdAt
      updatedAt
    }
  }
`;
export const listPlanPricings = /* GraphQL */ `
  query ListPlanPricings(
    $planId: ID
    $slug: ModelStringKeyConditionInput
    $filter: ModelPlanPricingFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listPlanPricings(
      planId: $planId
      slug: $slug
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        planId
        plan {
          id
          planGroupId
          planGroup {
            id
            name
            startDate
            endDate
            trialPeriod
            createdAt
            active
            updatedAt
          }
          name
          description
          active
          defaultPrice
          defaultPlanPriceId
          discountsAllowed
          display
          isTrial
          upgradeable
          downgradeable
          features
          createdAt
          level
          pricing {
            nextToken
          }
          metadata {
            coachingSessionsAllocated
            stripeProductId
          }
          updatedAt
        }
        slug
        default
        activationCodes
        downgradePricingIds
        upgradePricingIds
        price
        metadata {
          stripePriceId
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getEvent = /* GraphQL */ `
  query GetEvent($id: ID!) {
    getEvent(id: $id) {
      id
      name
      title
      description
      features {
        title
        description
      }
      startDate
      endDate
      startTimestamp
      endTimestamp
      timezone
      hostFirstName
      hostLastName
      hostEmail
      hostWebsite
      hostAvatar
      allowFreeMembers
      allowSprout
      allowBloom
      eventType
      attendeeLimit
      attendees {
        items {
          eventSessionId
          eventSession {
            id
            eventId
            sessionTitle
            sessionDescription
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            isRecurring
            allowFreeMembers
            allowSprout
            allowBloom
            attendeeLimit
            eventSessionFocusAreaId
            featureImageUrl
            createdAt
            updatedAt
          }
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          eventId
          event {
            id
            name
            title
            description
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            hostFirstName
            hostLastName
            hostEmail
            hostWebsite
            hostAvatar
            allowFreeMembers
            allowSprout
            allowBloom
            eventType
            attendeeLimit
            price
            featureImageUrl
            createdAt
            updatedAt
          }
          confirmed
          confirmationTimestamp
          metadata {
            paymentTimestamp
            stripeInvoiceId
            rawPaymentLog
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      times {
        items {
          eventId
          event {
            id
            name
            title
            description
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            hostFirstName
            hostLastName
            hostEmail
            hostWebsite
            hostAvatar
            allowFreeMembers
            allowSprout
            allowBloom
            eventType
            attendeeLimit
            price
            featureImageUrl
            createdAt
            updatedAt
          }
          name
          title
          type
          description
          startDate
          endDate
          timezone
          allowFreeMembers
          allowSprout
          allowBloom
          metadata {
            acuityCalendarId
            acuityAppointmentTypeId
            meetingLinkVideo
            meetingLinkAudio
            recordingLink
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      sessions {
        items {
          id
          eventId
          event {
            id
            name
            title
            description
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            hostFirstName
            hostLastName
            hostEmail
            hostWebsite
            hostAvatar
            allowFreeMembers
            allowSprout
            allowBloom
            eventType
            attendeeLimit
            price
            featureImageUrl
            createdAt
            updatedAt
          }
          sessionTitle
          sessionDescription
          startDate
          endDate
          startTimestamp
          endTimestamp
          timezone
          isRecurring
          allowFreeMembers
          allowSprout
          allowBloom
          attendeeLimit
          facilitators {
            nextToken
          }
          eventSessionAttendees {
            nextToken
          }
          times {
            nextToken
          }
          eventSessionFocusAreaId
          eventSessionFocusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          featureImageUrl
          metadata {
            chatChannelId
            eventSessionLandingPageUrl
            eventSessionMeetingLink
            actuityAppointmentTypeId
            acuityCalendarId
            activeCampaignTagId
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      price
      featureImageUrl
      metadata {
        stripeProductId
        stripePriceId
        eventLandingPageUrl
        eventMeetingLink
        activeCampaignTagId
        totalSessions
      }
      createdAt
      updatedAt
    }
  }
`;
export const listEvents = /* GraphQL */ `
  query ListEvents(
    $filter: ModelEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        title
        description
        features {
          title
          description
        }
        startDate
        endDate
        startTimestamp
        endTimestamp
        timezone
        hostFirstName
        hostLastName
        hostEmail
        hostWebsite
        hostAvatar
        allowFreeMembers
        allowSprout
        allowBloom
        eventType
        attendeeLimit
        attendees {
          items {
            eventSessionId
            userId
            eventId
            confirmed
            confirmationTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        times {
          items {
            eventId
            name
            title
            type
            description
            startDate
            endDate
            timezone
            allowFreeMembers
            allowSprout
            allowBloom
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            eventId
            sessionTitle
            sessionDescription
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            isRecurring
            allowFreeMembers
            allowSprout
            allowBloom
            attendeeLimit
            eventSessionFocusAreaId
            featureImageUrl
            createdAt
            updatedAt
          }
          nextToken
        }
        price
        featureImageUrl
        metadata {
          stripeProductId
          stripePriceId
          eventLandingPageUrl
          eventMeetingLink
          activeCampaignTagId
          totalSessions
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listEventsByStartDate = /* GraphQL */ `
  query ListEventsByStartDate(
    $startDate: AWSDateTime!
    $sortDirection: ModelSortDirection
    $filter: ModelEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventsByStartDate(
      startDate: $startDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        title
        description
        features {
          title
          description
        }
        startDate
        endDate
        startTimestamp
        endTimestamp
        timezone
        hostFirstName
        hostLastName
        hostEmail
        hostWebsite
        hostAvatar
        allowFreeMembers
        allowSprout
        allowBloom
        eventType
        attendeeLimit
        attendees {
          items {
            eventSessionId
            userId
            eventId
            confirmed
            confirmationTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        times {
          items {
            eventId
            name
            title
            type
            description
            startDate
            endDate
            timezone
            allowFreeMembers
            allowSprout
            allowBloom
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            eventId
            sessionTitle
            sessionDescription
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            isRecurring
            allowFreeMembers
            allowSprout
            allowBloom
            attendeeLimit
            eventSessionFocusAreaId
            featureImageUrl
            createdAt
            updatedAt
          }
          nextToken
        }
        price
        featureImageUrl
        metadata {
          stripeProductId
          stripePriceId
          eventLandingPageUrl
          eventMeetingLink
          activeCampaignTagId
          totalSessions
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listEventsByEventType = /* GraphQL */ `
  query ListEventsByEventType(
    $eventType: EventTypeEnum!
    $startDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventsByEventType(
      eventType: $eventType
      startDate: $startDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        title
        description
        features {
          title
          description
        }
        startDate
        endDate
        startTimestamp
        endTimestamp
        timezone
        hostFirstName
        hostLastName
        hostEmail
        hostWebsite
        hostAvatar
        allowFreeMembers
        allowSprout
        allowBloom
        eventType
        attendeeLimit
        attendees {
          items {
            eventSessionId
            userId
            eventId
            confirmed
            confirmationTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        times {
          items {
            eventId
            name
            title
            type
            description
            startDate
            endDate
            timezone
            allowFreeMembers
            allowSprout
            allowBloom
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            eventId
            sessionTitle
            sessionDescription
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            isRecurring
            allowFreeMembers
            allowSprout
            allowBloom
            attendeeLimit
            eventSessionFocusAreaId
            featureImageUrl
            createdAt
            updatedAt
          }
          nextToken
        }
        price
        featureImageUrl
        metadata {
          stripeProductId
          stripePriceId
          eventLandingPageUrl
          eventMeetingLink
          activeCampaignTagId
          totalSessions
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getEventTime = /* GraphQL */ `
  query GetEventTime($eventId: ID!, $startDate: AWSDateTime!) {
    getEventTime(eventId: $eventId, startDate: $startDate) {
      eventId
      event {
        id
        name
        title
        description
        features {
          title
          description
        }
        startDate
        endDate
        startTimestamp
        endTimestamp
        timezone
        hostFirstName
        hostLastName
        hostEmail
        hostWebsite
        hostAvatar
        allowFreeMembers
        allowSprout
        allowBloom
        eventType
        attendeeLimit
        attendees {
          items {
            eventSessionId
            userId
            eventId
            confirmed
            confirmationTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        times {
          items {
            eventId
            name
            title
            type
            description
            startDate
            endDate
            timezone
            allowFreeMembers
            allowSprout
            allowBloom
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            eventId
            sessionTitle
            sessionDescription
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            isRecurring
            allowFreeMembers
            allowSprout
            allowBloom
            attendeeLimit
            eventSessionFocusAreaId
            featureImageUrl
            createdAt
            updatedAt
          }
          nextToken
        }
        price
        featureImageUrl
        metadata {
          stripeProductId
          stripePriceId
          eventLandingPageUrl
          eventMeetingLink
          activeCampaignTagId
          totalSessions
        }
        createdAt
        updatedAt
      }
      name
      title
      type
      description
      startDate
      endDate
      timezone
      allowFreeMembers
      allowSprout
      allowBloom
      metadata {
        acuityCalendarId
        acuityAppointmentTypeId
        meetingLinkVideo
        meetingLinkAudio
        recordingLink
      }
      createdAt
      updatedAt
    }
  }
`;
export const listEventTimes = /* GraphQL */ `
  query ListEventTimes(
    $eventId: ID
    $startDate: ModelStringKeyConditionInput
    $filter: ModelEventTimeFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listEventTimes(
      eventId: $eventId
      startDate: $startDate
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        eventId
        event {
          id
          name
          title
          description
          features {
            title
            description
          }
          startDate
          endDate
          startTimestamp
          endTimestamp
          timezone
          hostFirstName
          hostLastName
          hostEmail
          hostWebsite
          hostAvatar
          allowFreeMembers
          allowSprout
          allowBloom
          eventType
          attendeeLimit
          attendees {
            nextToken
          }
          times {
            nextToken
          }
          sessions {
            nextToken
          }
          price
          featureImageUrl
          metadata {
            stripeProductId
            stripePriceId
            eventLandingPageUrl
            eventMeetingLink
            activeCampaignTagId
            totalSessions
          }
          createdAt
          updatedAt
        }
        name
        title
        type
        description
        startDate
        endDate
        timezone
        allowFreeMembers
        allowSprout
        allowBloom
        metadata {
          acuityCalendarId
          acuityAppointmentTypeId
          meetingLinkVideo
          meetingLinkAudio
          recordingLink
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getEventSession = /* GraphQL */ `
  query GetEventSession($id: ID!) {
    getEventSession(id: $id) {
      id
      eventId
      event {
        id
        name
        title
        description
        features {
          title
          description
        }
        startDate
        endDate
        startTimestamp
        endTimestamp
        timezone
        hostFirstName
        hostLastName
        hostEmail
        hostWebsite
        hostAvatar
        allowFreeMembers
        allowSprout
        allowBloom
        eventType
        attendeeLimit
        attendees {
          items {
            eventSessionId
            userId
            eventId
            confirmed
            confirmationTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        times {
          items {
            eventId
            name
            title
            type
            description
            startDate
            endDate
            timezone
            allowFreeMembers
            allowSprout
            allowBloom
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            eventId
            sessionTitle
            sessionDescription
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            isRecurring
            allowFreeMembers
            allowSprout
            allowBloom
            attendeeLimit
            eventSessionFocusAreaId
            featureImageUrl
            createdAt
            updatedAt
          }
          nextToken
        }
        price
        featureImageUrl
        metadata {
          stripeProductId
          stripePriceId
          eventLandingPageUrl
          eventMeetingLink
          activeCampaignTagId
          totalSessions
        }
        createdAt
        updatedAt
      }
      sessionTitle
      sessionDescription
      startDate
      endDate
      startTimestamp
      endTimestamp
      timezone
      isRecurring
      allowFreeMembers
      allowSprout
      allowBloom
      attendeeLimit
      facilitators {
        items {
          eventSessionId
          coachId
          coach {
            id
            firstName
            lastName
            email
            title
            coachType
            avatarUrl
            description
            active
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      eventSessionAttendees {
        items {
          eventSessionId
          eventSession {
            id
            eventId
            sessionTitle
            sessionDescription
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            isRecurring
            allowFreeMembers
            allowSprout
            allowBloom
            attendeeLimit
            eventSessionFocusAreaId
            featureImageUrl
            createdAt
            updatedAt
          }
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          eventId
          event {
            id
            name
            title
            description
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            hostFirstName
            hostLastName
            hostEmail
            hostWebsite
            hostAvatar
            allowFreeMembers
            allowSprout
            allowBloom
            eventType
            attendeeLimit
            price
            featureImageUrl
            createdAt
            updatedAt
          }
          confirmed
          confirmationTimestamp
          metadata {
            paymentTimestamp
            stripeInvoiceId
            rawPaymentLog
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      times {
        items {
          eventSessionId
          eventSession {
            id
            eventId
            sessionTitle
            sessionDescription
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            isRecurring
            allowFreeMembers
            allowSprout
            allowBloom
            attendeeLimit
            eventSessionFocusAreaId
            featureImageUrl
            createdAt
            updatedAt
          }
          eventId
          event {
            id
            name
            title
            description
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            hostFirstName
            hostLastName
            hostEmail
            hostWebsite
            hostAvatar
            allowFreeMembers
            allowSprout
            allowBloom
            eventType
            attendeeLimit
            price
            featureImageUrl
            createdAt
            updatedAt
          }
          name
          title
          type
          description
          startDate
          endDate
          timezone
          metadata {
            acuityCalendarId
            acuityAppointmentTypeId
            meetingLinkVideo
            meetingLinkAudio
            recordingLink
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      eventSessionFocusAreaId
      eventSessionFocusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      featureImageUrl
      metadata {
        chatChannelId
        eventSessionLandingPageUrl
        eventSessionMeetingLink
        actuityAppointmentTypeId
        acuityCalendarId
        activeCampaignTagId
      }
      createdAt
      updatedAt
    }
  }
`;
export const listEventSessions = /* GraphQL */ `
  query ListEventSessions(
    $filter: ModelEventSessionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventSessions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        eventId
        event {
          id
          name
          title
          description
          features {
            title
            description
          }
          startDate
          endDate
          startTimestamp
          endTimestamp
          timezone
          hostFirstName
          hostLastName
          hostEmail
          hostWebsite
          hostAvatar
          allowFreeMembers
          allowSprout
          allowBloom
          eventType
          attendeeLimit
          attendees {
            nextToken
          }
          times {
            nextToken
          }
          sessions {
            nextToken
          }
          price
          featureImageUrl
          metadata {
            stripeProductId
            stripePriceId
            eventLandingPageUrl
            eventMeetingLink
            activeCampaignTagId
            totalSessions
          }
          createdAt
          updatedAt
        }
        sessionTitle
        sessionDescription
        startDate
        endDate
        startTimestamp
        endTimestamp
        timezone
        isRecurring
        allowFreeMembers
        allowSprout
        allowBloom
        attendeeLimit
        facilitators {
          items {
            eventSessionId
            coachId
            createdAt
            updatedAt
          }
          nextToken
        }
        eventSessionAttendees {
          items {
            eventSessionId
            userId
            eventId
            confirmed
            confirmationTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        times {
          items {
            eventSessionId
            eventId
            name
            title
            type
            description
            startDate
            endDate
            timezone
            createdAt
            updatedAt
          }
          nextToken
        }
        eventSessionFocusAreaId
        eventSessionFocusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        featureImageUrl
        metadata {
          chatChannelId
          eventSessionLandingPageUrl
          eventSessionMeetingLink
          actuityAppointmentTypeId
          acuityCalendarId
          activeCampaignTagId
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getEventSessionTime = /* GraphQL */ `
  query GetEventSessionTime($eventSessionId: ID!, $startDate: AWSDateTime!) {
    getEventSessionTime(
      eventSessionId: $eventSessionId
      startDate: $startDate
    ) {
      eventSessionId
      eventSession {
        id
        eventId
        event {
          id
          name
          title
          description
          features {
            title
            description
          }
          startDate
          endDate
          startTimestamp
          endTimestamp
          timezone
          hostFirstName
          hostLastName
          hostEmail
          hostWebsite
          hostAvatar
          allowFreeMembers
          allowSprout
          allowBloom
          eventType
          attendeeLimit
          attendees {
            nextToken
          }
          times {
            nextToken
          }
          sessions {
            nextToken
          }
          price
          featureImageUrl
          metadata {
            stripeProductId
            stripePriceId
            eventLandingPageUrl
            eventMeetingLink
            activeCampaignTagId
            totalSessions
          }
          createdAt
          updatedAt
        }
        sessionTitle
        sessionDescription
        startDate
        endDate
        startTimestamp
        endTimestamp
        timezone
        isRecurring
        allowFreeMembers
        allowSprout
        allowBloom
        attendeeLimit
        facilitators {
          items {
            eventSessionId
            coachId
            createdAt
            updatedAt
          }
          nextToken
        }
        eventSessionAttendees {
          items {
            eventSessionId
            userId
            eventId
            confirmed
            confirmationTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        times {
          items {
            eventSessionId
            eventId
            name
            title
            type
            description
            startDate
            endDate
            timezone
            createdAt
            updatedAt
          }
          nextToken
        }
        eventSessionFocusAreaId
        eventSessionFocusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        featureImageUrl
        metadata {
          chatChannelId
          eventSessionLandingPageUrl
          eventSessionMeetingLink
          actuityAppointmentTypeId
          acuityCalendarId
          activeCampaignTagId
        }
        createdAt
        updatedAt
      }
      eventId
      event {
        id
        name
        title
        description
        features {
          title
          description
        }
        startDate
        endDate
        startTimestamp
        endTimestamp
        timezone
        hostFirstName
        hostLastName
        hostEmail
        hostWebsite
        hostAvatar
        allowFreeMembers
        allowSprout
        allowBloom
        eventType
        attendeeLimit
        attendees {
          items {
            eventSessionId
            userId
            eventId
            confirmed
            confirmationTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        times {
          items {
            eventId
            name
            title
            type
            description
            startDate
            endDate
            timezone
            allowFreeMembers
            allowSprout
            allowBloom
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            eventId
            sessionTitle
            sessionDescription
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            isRecurring
            allowFreeMembers
            allowSprout
            allowBloom
            attendeeLimit
            eventSessionFocusAreaId
            featureImageUrl
            createdAt
            updatedAt
          }
          nextToken
        }
        price
        featureImageUrl
        metadata {
          stripeProductId
          stripePriceId
          eventLandingPageUrl
          eventMeetingLink
          activeCampaignTagId
          totalSessions
        }
        createdAt
        updatedAt
      }
      name
      title
      type
      description
      startDate
      endDate
      timezone
      metadata {
        acuityCalendarId
        acuityAppointmentTypeId
        meetingLinkVideo
        meetingLinkAudio
        recordingLink
      }
      createdAt
      updatedAt
    }
  }
`;
export const listEventSessionTimes = /* GraphQL */ `
  query ListEventSessionTimes(
    $eventSessionId: ID
    $startDate: ModelStringKeyConditionInput
    $filter: ModelEventSessionTimeFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listEventSessionTimes(
      eventSessionId: $eventSessionId
      startDate: $startDate
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        eventSessionId
        eventSession {
          id
          eventId
          event {
            id
            name
            title
            description
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            hostFirstName
            hostLastName
            hostEmail
            hostWebsite
            hostAvatar
            allowFreeMembers
            allowSprout
            allowBloom
            eventType
            attendeeLimit
            price
            featureImageUrl
            createdAt
            updatedAt
          }
          sessionTitle
          sessionDescription
          startDate
          endDate
          startTimestamp
          endTimestamp
          timezone
          isRecurring
          allowFreeMembers
          allowSprout
          allowBloom
          attendeeLimit
          facilitators {
            nextToken
          }
          eventSessionAttendees {
            nextToken
          }
          times {
            nextToken
          }
          eventSessionFocusAreaId
          eventSessionFocusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          featureImageUrl
          metadata {
            chatChannelId
            eventSessionLandingPageUrl
            eventSessionMeetingLink
            actuityAppointmentTypeId
            acuityCalendarId
            activeCampaignTagId
          }
          createdAt
          updatedAt
        }
        eventId
        event {
          id
          name
          title
          description
          features {
            title
            description
          }
          startDate
          endDate
          startTimestamp
          endTimestamp
          timezone
          hostFirstName
          hostLastName
          hostEmail
          hostWebsite
          hostAvatar
          allowFreeMembers
          allowSprout
          allowBloom
          eventType
          attendeeLimit
          attendees {
            nextToken
          }
          times {
            nextToken
          }
          sessions {
            nextToken
          }
          price
          featureImageUrl
          metadata {
            stripeProductId
            stripePriceId
            eventLandingPageUrl
            eventMeetingLink
            activeCampaignTagId
            totalSessions
          }
          createdAt
          updatedAt
        }
        name
        title
        type
        description
        startDate
        endDate
        timezone
        metadata {
          acuityCalendarId
          acuityAppointmentTypeId
          meetingLinkVideo
          meetingLinkAudio
          recordingLink
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getEventSessionFacilitator = /* GraphQL */ `
  query GetEventSessionFacilitator($eventSessionId: ID!, $coachId: ID!) {
    getEventSessionFacilitator(
      eventSessionId: $eventSessionId
      coachId: $coachId
    ) {
      eventSessionId
      coachId
      coach {
        id
        firstName
        lastName
        email
        title
        coachType
        avatarUrl
        description
        metadata {
          introVideoUrl
          gcalId
          calendlyId
          acuityCalendarId
          acuityUserId
          acuityKey
          acuityIssAppointmentId
          acuityRegularAppointmentId
          streamChatId
          slackId
          lastCoachNote
          lastChatMessage
        }
        focusAreas {
          items {
            id
            coachId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        members {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listEventSessionFacilitators = /* GraphQL */ `
  query ListEventSessionFacilitators(
    $eventSessionId: ID
    $coachId: ModelIDKeyConditionInput
    $filter: ModelEventSessionFacilitatorFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listEventSessionFacilitators(
      eventSessionId: $eventSessionId
      coachId: $coachId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        eventSessionId
        coachId
        coach {
          id
          firstName
          lastName
          email
          title
          coachType
          avatarUrl
          description
          metadata {
            introVideoUrl
            gcalId
            calendlyId
            acuityCalendarId
            acuityUserId
            acuityKey
            acuityIssAppointmentId
            acuityRegularAppointmentId
            streamChatId
            slackId
            lastCoachNote
            lastChatMessage
          }
          focusAreas {
            nextToken
          }
          members {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getEventSessionAttendees = /* GraphQL */ `
  query GetEventSessionAttendees($eventSessionId: ID!, $userId: ID!) {
    getEventSessionAttendees(eventSessionId: $eventSessionId, userId: $userId) {
      eventSessionId
      eventSession {
        id
        eventId
        event {
          id
          name
          title
          description
          features {
            title
            description
          }
          startDate
          endDate
          startTimestamp
          endTimestamp
          timezone
          hostFirstName
          hostLastName
          hostEmail
          hostWebsite
          hostAvatar
          allowFreeMembers
          allowSprout
          allowBloom
          eventType
          attendeeLimit
          attendees {
            nextToken
          }
          times {
            nextToken
          }
          sessions {
            nextToken
          }
          price
          featureImageUrl
          metadata {
            stripeProductId
            stripePriceId
            eventLandingPageUrl
            eventMeetingLink
            activeCampaignTagId
            totalSessions
          }
          createdAt
          updatedAt
        }
        sessionTitle
        sessionDescription
        startDate
        endDate
        startTimestamp
        endTimestamp
        timezone
        isRecurring
        allowFreeMembers
        allowSprout
        allowBloom
        attendeeLimit
        facilitators {
          items {
            eventSessionId
            coachId
            createdAt
            updatedAt
          }
          nextToken
        }
        eventSessionAttendees {
          items {
            eventSessionId
            userId
            eventId
            confirmed
            confirmationTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        times {
          items {
            eventSessionId
            eventId
            name
            title
            type
            description
            startDate
            endDate
            timezone
            createdAt
            updatedAt
          }
          nextToken
        }
        eventSessionFocusAreaId
        eventSessionFocusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        featureImageUrl
        metadata {
          chatChannelId
          eventSessionLandingPageUrl
          eventSessionMeetingLink
          actuityAppointmentTypeId
          acuityCalendarId
          activeCampaignTagId
        }
        createdAt
        updatedAt
      }
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      eventId
      event {
        id
        name
        title
        description
        features {
          title
          description
        }
        startDate
        endDate
        startTimestamp
        endTimestamp
        timezone
        hostFirstName
        hostLastName
        hostEmail
        hostWebsite
        hostAvatar
        allowFreeMembers
        allowSprout
        allowBloom
        eventType
        attendeeLimit
        attendees {
          items {
            eventSessionId
            userId
            eventId
            confirmed
            confirmationTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        times {
          items {
            eventId
            name
            title
            type
            description
            startDate
            endDate
            timezone
            allowFreeMembers
            allowSprout
            allowBloom
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            eventId
            sessionTitle
            sessionDescription
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            isRecurring
            allowFreeMembers
            allowSprout
            allowBloom
            attendeeLimit
            eventSessionFocusAreaId
            featureImageUrl
            createdAt
            updatedAt
          }
          nextToken
        }
        price
        featureImageUrl
        metadata {
          stripeProductId
          stripePriceId
          eventLandingPageUrl
          eventMeetingLink
          activeCampaignTagId
          totalSessions
        }
        createdAt
        updatedAt
      }
      confirmed
      confirmationTimestamp
      metadata {
        paymentTimestamp
        stripeInvoiceId
        rawPaymentLog
      }
      createdAt
      updatedAt
    }
  }
`;
export const listEventSessionAttendees = /* GraphQL */ `
  query ListEventSessionAttendees(
    $eventSessionId: ID
    $userId: ModelIDKeyConditionInput
    $filter: ModelEventSessionAttendeesFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listEventSessionAttendees(
      eventSessionId: $eventSessionId
      userId: $userId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        eventSessionId
        eventSession {
          id
          eventId
          event {
            id
            name
            title
            description
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            hostFirstName
            hostLastName
            hostEmail
            hostWebsite
            hostAvatar
            allowFreeMembers
            allowSprout
            allowBloom
            eventType
            attendeeLimit
            price
            featureImageUrl
            createdAt
            updatedAt
          }
          sessionTitle
          sessionDescription
          startDate
          endDate
          startTimestamp
          endTimestamp
          timezone
          isRecurring
          allowFreeMembers
          allowSprout
          allowBloom
          attendeeLimit
          facilitators {
            nextToken
          }
          eventSessionAttendees {
            nextToken
          }
          times {
            nextToken
          }
          eventSessionFocusAreaId
          eventSessionFocusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          featureImageUrl
          metadata {
            chatChannelId
            eventSessionLandingPageUrl
            eventSessionMeetingLink
            actuityAppointmentTypeId
            acuityCalendarId
            activeCampaignTagId
          }
          createdAt
          updatedAt
        }
        userId
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        eventId
        event {
          id
          name
          title
          description
          features {
            title
            description
          }
          startDate
          endDate
          startTimestamp
          endTimestamp
          timezone
          hostFirstName
          hostLastName
          hostEmail
          hostWebsite
          hostAvatar
          allowFreeMembers
          allowSprout
          allowBloom
          eventType
          attendeeLimit
          attendees {
            nextToken
          }
          times {
            nextToken
          }
          sessions {
            nextToken
          }
          price
          featureImageUrl
          metadata {
            stripeProductId
            stripePriceId
            eventLandingPageUrl
            eventMeetingLink
            activeCampaignTagId
            totalSessions
          }
          createdAt
          updatedAt
        }
        confirmed
        confirmationTimestamp
        metadata {
          paymentTimestamp
          stripeInvoiceId
          rawPaymentLog
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getEventAttendeeByUserId = /* GraphQL */ `
  query GetEventAttendeeByUserId(
    $userId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEventSessionAttendeesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getEventAttendeeByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        eventSessionId
        eventSession {
          id
          eventId
          event {
            id
            name
            title
            description
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            hostFirstName
            hostLastName
            hostEmail
            hostWebsite
            hostAvatar
            allowFreeMembers
            allowSprout
            allowBloom
            eventType
            attendeeLimit
            price
            featureImageUrl
            createdAt
            updatedAt
          }
          sessionTitle
          sessionDescription
          startDate
          endDate
          startTimestamp
          endTimestamp
          timezone
          isRecurring
          allowFreeMembers
          allowSprout
          allowBloom
          attendeeLimit
          facilitators {
            nextToken
          }
          eventSessionAttendees {
            nextToken
          }
          times {
            nextToken
          }
          eventSessionFocusAreaId
          eventSessionFocusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          featureImageUrl
          metadata {
            chatChannelId
            eventSessionLandingPageUrl
            eventSessionMeetingLink
            actuityAppointmentTypeId
            acuityCalendarId
            activeCampaignTagId
          }
          createdAt
          updatedAt
        }
        userId
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        eventId
        event {
          id
          name
          title
          description
          features {
            title
            description
          }
          startDate
          endDate
          startTimestamp
          endTimestamp
          timezone
          hostFirstName
          hostLastName
          hostEmail
          hostWebsite
          hostAvatar
          allowFreeMembers
          allowSprout
          allowBloom
          eventType
          attendeeLimit
          attendees {
            nextToken
          }
          times {
            nextToken
          }
          sessions {
            nextToken
          }
          price
          featureImageUrl
          metadata {
            stripeProductId
            stripePriceId
            eventLandingPageUrl
            eventMeetingLink
            activeCampaignTagId
            totalSessions
          }
          createdAt
          updatedAt
        }
        confirmed
        confirmationTimestamp
        metadata {
          paymentTimestamp
          stripeInvoiceId
          rawPaymentLog
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listEventSessionAttendeesByEventId = /* GraphQL */ `
  query ListEventSessionAttendeesByEventId(
    $eventId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEventSessionAttendeesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventSessionAttendeesByEventId(
      eventId: $eventId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        eventSessionId
        eventSession {
          id
          eventId
          event {
            id
            name
            title
            description
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            hostFirstName
            hostLastName
            hostEmail
            hostWebsite
            hostAvatar
            allowFreeMembers
            allowSprout
            allowBloom
            eventType
            attendeeLimit
            price
            featureImageUrl
            createdAt
            updatedAt
          }
          sessionTitle
          sessionDescription
          startDate
          endDate
          startTimestamp
          endTimestamp
          timezone
          isRecurring
          allowFreeMembers
          allowSprout
          allowBloom
          attendeeLimit
          facilitators {
            nextToken
          }
          eventSessionAttendees {
            nextToken
          }
          times {
            nextToken
          }
          eventSessionFocusAreaId
          eventSessionFocusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          featureImageUrl
          metadata {
            chatChannelId
            eventSessionLandingPageUrl
            eventSessionMeetingLink
            actuityAppointmentTypeId
            acuityCalendarId
            activeCampaignTagId
          }
          createdAt
          updatedAt
        }
        userId
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        eventId
        event {
          id
          name
          title
          description
          features {
            title
            description
          }
          startDate
          endDate
          startTimestamp
          endTimestamp
          timezone
          hostFirstName
          hostLastName
          hostEmail
          hostWebsite
          hostAvatar
          allowFreeMembers
          allowSprout
          allowBloom
          eventType
          attendeeLimit
          attendees {
            nextToken
          }
          times {
            nextToken
          }
          sessions {
            nextToken
          }
          price
          featureImageUrl
          metadata {
            stripeProductId
            stripePriceId
            eventLandingPageUrl
            eventMeetingLink
            activeCampaignTagId
            totalSessions
          }
          createdAt
          updatedAt
        }
        confirmed
        confirmationTimestamp
        metadata {
          paymentTimestamp
          stripeInvoiceId
          rawPaymentLog
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
